/* eslint-disable  */
import React, {
  useRef,
  useState,
  useEffect,
  useMemo,
  useCallback,
  forwardRef,
  Fragment,
} from 'react';
import { history } from 'umi';
import ProTable from '@ant-design/pro-table';
// import Video from '@/components/Video';
import Xgplayer from 'xgplayer-react';

import {
  roomCtl,
  queryClassList,
  queryClassLiveLink,
  queryClassDetailContent,
  getAttendStatus,
  getCourseAttendRecord,
  getUserByTelephone,
  queryCoachList,
  getWeekPerformList,
  getWeeklyCoursesByWeekNo,
  appointClass,
  // cancelClassRoom,
  getCoursePlanDetail,
  classEventRecord,
  getCourseTemplateList,
  modifyClass,
  listReason,
  cancelClass,
  getCancelInfo,
  cancelWarn,
  shield,
  unblock,
  remarkDetailByRoomId,
  getClassRoom,
  queryCategories,
  getCompleteClassInfoForPalmer,
  getCompleteActionDetailGptResponse,
  classActionKeypointsReview,
  classActionKeypointsReliabilitySummary,
  summarize,
  v3AnalysisDetail,
} from '@/services/operating';
import {
  Typography,
  Button,
  Space,
  Modal,
  Form,
  DatePicker,
  Select,
  Radio,
  Tabs,
  Input,
  Row,
  Col,
  Message,
  Descriptions,
  Steps,
  message,
  Image,
  Tag,
  Slider,
  Tooltip,
} from 'antd';
import QRCode from 'qrcode.react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import ModalVideo from '@/components/ModalVideoXg';

import moment from 'moment';
import { PlayCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { guuid } from '@/utils/utils';
import ClassCommentView from '../ClassCommentView';
import ClassActionView from '../ClassActionView';
import CourserInfoView from '../CourseInfoView';
import V3AnalysisTab from '../V3AnalysisTab';
import KeypointPlayer from '@/pages/activity/vitalityGo/KeypointPlayer';
import { formatTime } from '@/utils/utils';
import { debounce } from '@/utils/utils';
const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;
const { TextArea } = Input;
const { Step } = Steps;

const KEYPOINT_SOURCE_WIDTH = 640;
const KEYPOINT_SOURCE_HEIGHT = 480;
const KEYPOINT_COLOR = '#9FE8B2';
const KEYPOINT_PLAYER_WIDTH = 336;
const KEYPOINT_PLAYER_HEIGHT = 224;
const CREDIBILITY_PLAY_INTERVAL_MS = 67;
const DEFAULT_IN_FRAME_THRESHOLD = 90;
const DEFAULT_VARIANCE_THRESHOLD = 5;
const DEFAULT_CREDIBLE_MINUTE_THRESHOLD = 20;
const DEFAULT_STATIC_CONFIG_THRESHOLD = 90;
const KEYPOINT_LINKS = [
  [0, 1],
  [0, 2],
  [1, 3],
  [2, 4],
  [5, 6],
  [5, 7],
  [7, 9],
  [6, 8],
  [8, 10],
  [5, 11],
  [6, 12],
  [11, 12],
  [11, 13],
  [13, 15],
  [12, 14],
  [14, 16],
];

// ===================== 骨骼点平滑动画 Hook =====================
class OneEuroFilter {
  constructor(minCutoff = 1.0, beta = 0.001, dCutoff = 1.0) {
    this.minCutoff = minCutoff;
    this.beta = beta;
    this.dCutoff = dCutoff;
    this.xPrev = null;
    this.dxPrev = null;
    this.tPrev = null;
  }

  alpha(dt, cutoff) {
    const tau = 1.0 / (2 * Math.PI * cutoff);
    return 1.0 / (1.0 + tau / dt);
  }

  filter(x, t) {
    if (this.tPrev === null) {
      this.xPrev = x;
      this.dxPrev = 0;
      this.tPrev = t;
      return x;
    }
    const dt = (t - this.tPrev) / 1000.0;
    if (dt <= 0) return x;
    const dx = (x - this.xPrev) / dt;
    const edx =
      this.alpha(dt, this.dCutoff) * dx +
      (1 - this.alpha(dt, this.dCutoff)) * this.dxPrev;
    const cutoff = this.minCutoff + this.beta * Math.abs(edx);
    const a = this.alpha(dt, cutoff);
    const xFiltered = a * x + (1 - a) * this.xPrev;
    this.xPrev = xFiltered;
    this.dxPrev = edx;
    this.tPrev = t;
    return xFiltered;
  }

  reset() {
    this.xPrev = null;
    this.dxPrev = null;
    this.tPrev = null;
  }
}

class OneEuroFilter2D {
  constructor(minCutoff = 0.05, beta = 0.005, dCutoff = 1.0) {
    this.xFilter = new OneEuroFilter(minCutoff, beta, dCutoff);
    this.yFilter = new OneEuroFilter(minCutoff, beta, dCutoff);
  }

  filter(x, y, t) {
    return {
      x: this.xFilter.filter(x, t),
      y: this.yFilter.filter(y, t),
    };
  }

  reset() {
    this.xFilter.reset();
    this.yFilter.reset();
  }
}

const useKeypointSmoothing = (keypointCount = 17) => {
  const filtersRef = useRef([]);

  if (filtersRef.current.length === 0) {
    for (let i = 0; i < keypointCount; i++) {
      filtersRef.current.push(new OneEuroFilter2D(0.05, 0.005, 1.0));
    }
  }

  const smoothKeypoints = useCallback((keypoints) => {
    const t = performance.now();
    return keypoints.map((kp, i) => {
      if (kp && Number.isFinite(kp.x) && Number.isFinite(kp.y)) {
        const smoothed = filtersRef.current[i]?.filter(kp.x, kp.y, t);
        return smoothed ? { ...kp, x: smoothed.x, y: smoothed.y } : kp;
      } else {
        filtersRef.current[i]?.reset();
        return kp;
      }
    });
  }, []);

  const resetFilters = useCallback(() => {
    filtersRef.current.forEach((f) => f.reset());
  }, []);

  return { smoothKeypoints, resetFilters };
};

// ===================== KeypointCanvas 组件 =====================
const KeypointCanvas = ({
  keypoints = [],
  canvasWidth = KEYPOINT_PLAYER_WIDTH,
  canvasHeight = KEYPOINT_PLAYER_HEIGHT,
  pointRadius = 3,
  enableSmoothing = false,
}) => {
  const canvasRef = useRef(null);
  const { smoothKeypoints } = useKeypointSmoothing(17);
  const lastKeypointsRef = useRef([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) {
      return;
    }
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvasWidth, canvasHeight);

    let processedKeypoints = keypoints || [];

    // 应用平滑滤波
    if (enableSmoothing && processedKeypoints.length > 0) {
      if (lastKeypointsRef.current.length === 0) {
        lastKeypointsRef.current = processedKeypoints;
      }
      processedKeypoints = smoothKeypoints(processedKeypoints);
    }

    const normalizedPoints = processedKeypoints.map((point) => ({
      x: Number(point?.x),
      y: Number(point?.y),
      score: point?.score,
    }));

    const scaleX = canvasWidth / KEYPOINT_SOURCE_WIDTH;
    const scaleY = canvasHeight / KEYPOINT_SOURCE_HEIGHT;
    const isValidPoint = (point) =>
      point &&
      Number.isFinite(point.x) &&
      Number.isFinite(point.y) &&
      point.x >= 0 &&
      point.y >= 0;

    if (!normalizedPoints.length) {
      return;
    }

    ctx.strokeStyle = KEYPOINT_COLOR;
    ctx.lineWidth = 2;

    // 0 鼻子 - 用于简化头部
    const nose = normalizedPoints[0];

    // 绘制身体骨架（跳过头部连接）
    KEYPOINT_LINKS.forEach(([startIndex, endIndex]) => {
      // 跳过涉及头部点位的连接（鼻子、左眼、右眼、左耳、右耳）
      if (
        [0, 1, 2, 3, 4].includes(startIndex) ||
        [0, 1, 2, 3, 4].includes(endIndex)
      ) {
        return;
      }

      const startPoint = normalizedPoints[startIndex];
      const endPoint = normalizedPoints[endIndex];
      if (!isValidPoint(startPoint) || !isValidPoint(endPoint)) {
        return;
      }

      ctx.beginPath();
      ctx.moveTo(startPoint.x * scaleX, startPoint.y * scaleY);
      ctx.lineTo(endPoint.x * scaleX, endPoint.y * scaleY);
      ctx.stroke();
    });

    // 绘制鼻子（仅保留鼻子点位作为头部标识）
    if (isValidPoint(nose)) {
      ctx.beginPath();
      ctx.arc(
        nose.x * scaleX,
        nose.y * scaleY,
        pointRadius * 2,
        0,
        2 * Math.PI,
      );
      ctx.fillStyle = KEYPOINT_COLOR;
      ctx.fill();
    }

    // 绘制所有关节点（跳过头部点位：鼻子、左眼、右眼、左耳、右耳）
    ctx.fillStyle = KEYPOINT_COLOR;
    normalizedPoints.forEach((point, index) => {
      // 跳过头部相关点位（索引 0-4）
      if (index <= 4) {
        return;
      }
      if (!isValidPoint(point)) {
        return;
      }
      ctx.beginPath();
      ctx.arc(point.x * scaleX, point.y * scaleY, pointRadius, 0, 2 * Math.PI);
      ctx.fill();
    });
  }, [
    keypoints,
    canvasWidth,
    canvasHeight,
    pointRadius,
    enableSmoothing,
    smoothKeypoints,
  ]);

  return (
    <canvas
      ref={canvasRef}
      width={canvasWidth}
      height={canvasHeight}
      style={{
        width: canvasWidth,
        height: canvasHeight,
        border: '1px solid #d9d9d9',
      }}
    />
  );
};

const ClassList = (props, ref) => {
  const [userPhoneInit, setUserPhoneInit] = useState(props.userPhoneInit);
  const [userIdInit, setUserIdInit] = useState(props.userIdInit);
  const { startTimeInit, userRecordInit, sort, classStatusInit, roomId } =
    props;

  // 字组件刷新：参数变更,刷新列表
  useEffect(() => {
    setUserPhoneInit(props.userPhoneInit);
    setUserIdInit(props.userIdInit);
  }, [props.userPhoneInit, props.userIdInit]);

  useEffect(() => {
    console.log('roomId', roomId);
    if (roomId) {
      actionFormRef?.current?.resetFields();
      actionFormRef?.current?.setFieldsValue({
        roomId: roomId,
      });
    }

    // actionRef.current.reload();
    if (actionFormRef?.current) {
      actionFormRef?.current?.submit();
    } else {
      reloadData();
    }
  }, [userPhoneInit, userIdInit]);

  const reloadData = debounce(() => {
    actionRef.current.reload();
  }, 600);

  const [orderUserForm] = Form.useForm();
  const [orderCourseForm] = Form.useForm();
  const [current, setCurrent] = useState(0);
  const [userId, setUserId] = useState();
  const [userName, setUserName] = useState();
  const [userPhone, setUserPhone] = useState();
  const [classType, setClassType] = useState(1);

  const [planType, setPlanType] = useState();
  const [templateList, setTemplateList] = useState([]);

  const [isBeginPlay, setBeginPlay] = useState(false);

  const [cancelRecord, setCancelRecord] = useState();
  const [isCancelModalVisible, setIsCancelModalVisible] = useState(false);
  const [cancelCourseForm] = Form.useForm();
  const [reasonList, setReasonList] = useState([]);

  const [isReasonModalVisible, setIsReasonModalVisible] = useState(false);
  const [reasonRecord, setReasonRecord] = useState();
  const [cancelData, setCancelData] = useState();

  // 教练评语
  const [commentData, setCommentData] = useState();
  // 作业点评
  const [classCommentVisible, setClassCommentVisible] = useState(false);
  const [classCommentRecord, setClassCommentRecord] = useState();
  const [classCommentInfoList, setClassCommentInfoList] = useState();
  const [remarkDetailData, setRemarkDetailData] = useState();

  const [classCategoryEnum, setClassCategoryEnum] = useState([]);
  const [classRoomCategoryList, setClassRoomCategoryList] = useState([]);
  const [completeClassInfo, setCompleteClassInfo] = useState({});
  const [completeClassCommentInfo, setCompleteClassCommentInfo] = useState({});
  const [summaryInput, setSummaryInput] = useState('');
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [credibilityLoading, setCredibilityLoading] = useState(false);
  const [credibilityMetricsLoading, setCredibilityMetricsLoading] =
    useState(false);
  const [credibilityActionMetrics, setCredibilityActionMetrics] = useState([]);
  const [credibilityFrames, setCredibilityFrames] = useState([]);
  const [credibilityJsonlUrl, setCredibilityJsonlUrl] = useState('');
  const [credibilityJsonlFrames, setCredibilityJsonlFrames] = useState([]);
  const keypointPlayerRef = useRef(null);
  const [selectedCredAction, setSelectedCredAction] = useState();
  const [selectedCredMetric, setSelectedCredMetric] = useState();
  const [credCurrentFrameIndex, setCredCurrentFrameIndex] = useState(0);
  const [credibilitySummaryData, setCredibilitySummaryData] = useState({});
  const [inFrameThreshold, setInFrameThreshold] = useState(
    DEFAULT_IN_FRAME_THRESHOLD,
  );
  const [varianceThreshold, setVarianceThreshold] = useState(
    DEFAULT_VARIANCE_THRESHOLD,
  );
  const [credibleMinuteThreshold, setCredibleMinuteThreshold] = useState(
    DEFAULT_CREDIBLE_MINUTE_THRESHOLD,
  );
  const [staticConfigThreshold, setStaticConfigThreshold] = useState(
    DEFAULT_STATIC_CONFIG_THRESHOLD,
  );

  const xpCommentEnum = {
    1: '未点评',
    2: '部分点评',
    3: '已点评',
  };

  const hasTemplateId = (modifyId) => {
    if (!modifyId) {
      return false;
    }
    var rst = false;
    templateList.forEach((e) => {
      if (e.templateId == modifyId) {
        rst = true;
      }
    });
    return rst;
  };

  function getCategoryName(category) {
    let name = '';
    classRoomCategoryList.forEach((e) => {
      if (e.category === category) {
        name = e.categoryName;
      }
    });
    return name;
  }

  const onPlanTypeChange = (e) => {
    console.log(e);
    setPlanType(e);
  };
  // 强制关流
  const forceClose = (record) => {
    // 3 关闭
    roomCtrl(record, 3);
  };
  /// 房间操作
  const roomCtrl = async (record, option) => {
    const params = {
      roomId: record.roomId,
      option: option,
      record: false,
    };
    const { code, msg } = await roomCtl({
      requestData: {
        ...params,
      },
    });
    if (code === '00000') {
      Message.success('操作成功！');
    } else {
      Message.error(msg);
    }
  };

  // 修改弹窗
  const [orderModifyForm] = Form.useForm();
  const [modifyRecord, setModifyRecord] = useState();
  const [modifyVisible, setModifyVisible] = useState(false);
  const handleModifyModalOk = () => {
    // 验证参数
    const formValues = orderModifyForm.getFieldsValue([
      'beginTime',
      'coach',
      'templateId',
    ]);
    orderModifyForm
      .validateFields(['beginTime', 'coach', 'templateId'])
      .then((value) => {
        const params = {
          // coachId: formValues.coach,
          startDateTime: moment(startTime).format('x'),
          // endDateTime: moment(startTime)
          //   .add(45, 'minutes')
          //   .format('x'),
        };

        /// TODO： 更改

        // if (!!formValues.coach) {
        params.coachId = formValues?.coach;
        // } else {
        //   //未修改 使用之前的
        //   params['coachId'] = formValues.coachId;
        // }
        params.classType = modifyRecord?.classType;
        if (modifyRecord?.classType == 1) {
          //防止返回的值为字符串 ==
          params.templateId = formValues?.templateId;
        } else {
          params.courseId = selectPlanNo;
        }

        params.telephone = modifyRecord?.userPhone;
        params.userId = modifyRecord?.userId;
        params.roomId = modifyRecord?.roomId;

        modifyClass({
          requestData: params,
        }).then(({ data, code, msg }) => {
          if (code === '00000') {
            actionRef.current.reload();
            setModifyRecord(undefined);
            setModifyVisible(false);
          } else {
            message.error(msg);
          }
        });
      });
  };
  const handleModifyModalCancel = () => {
    setModifyRecord(undefined);
    setModifyVisible(false);
  };

  // 开始时间
  const [startTime, setStartTime] = useState();
  const [pickCoachList, setPickCoachList] = useState([]);

  const getCoachStr = (coachItem) => {
    // 数据转换
    let tempStr = '';
    const len = coachItem?.coachClassList?.length;
    if (len > 0) {
      for (let i = 0; i < len; i++) {
        const item = coachItem.coachClassList[i];
        const timeStr = item.startClassTime + '至' + item.endClassTime;
        if (i > 0) {
          tempStr += ',';
        }
        if (i === 0) {
          tempStr = timeStr;
        } else {
          tempStr += timeStr;
        }
      }
    }
    if (tempStr.length > 0) {
      tempStr = '(' + tempStr + ')';
    }

    return coachItem.nickName + tempStr;
  };

  // 周
  const [selectWeekNo, setSelectWeekNo] = useState();
  const [weekPerformList, setWeekPerformList] = useState([]);

  const [selectPlanNo, setSelectPlanNo] = useState();
  const [planList, setPlanList] = useState([]);

  const onClassTypeChange = (e) => {
    ///回调的值被改为了 string  ！！！
    setClassType(parseInt(e.target.value));
  };

  const onWeekNoChange = (value) => {
    setSelectWeekNo(value);
  };

  const onPlanChange = (value) => {
    setSelectPlanNo(value);
  };

  const onOk = (value) => {
    setStartTime(value);
  };

  const moveNext = () => {
    if (current === 0) {
      // 请求user_id
      const form0Values = orderUserForm.getFieldsValue([
        'telephone',
        'classType',
      ]);
      orderUserForm.validateFields(['telephone', 'classType']).then((value) => {
        setUserPhone(form0Values.telephone);

        getUserByTelephone({
          requestData: {
            telephone: form0Values.telephone,
          },
        }).then(({ data, code, msg }) => {
          if (code === '00000') {
            setUserId(data?.userId);
            setUserName(data?.nickName);
            if (form0Values.classType == 1) {
              // 查询计划
              setCurrent(1);
            } else if (form0Values.classType == 2) {
              // 查询计划
              getWeekPerformList({
                requestData: {
                  innerUserId: data?.userId,
                  telephone: form0Values.telephone,
                },
              }).then(({ data, code, msg }) => {
                if (code === '00000') {
                  setWeekPerformList(data || []);
                  setCurrent(1);
                } else {
                  message.error(msg);
                }
              });
            }
          } else {
            message.error(msg);
          }
        });
      });
    } else if (current === 1) {
      const form1Values = orderCourseForm.getFieldsValue([
        'beginTime',
        'coach',
      ]);
      orderCourseForm.validateFields(['beginTime', 'coach']).then((value) => {
        const params = {
          userId: userId,
          telephone: userPhone,
          coachId: form1Values.coach,
          classType: classType,
          startDateTime: moment(startTime).format('x'),
          // endDateTime: moment(startTime)
          //   .add(45, 'minutes')
          //   .format('x'),
        };
        if (classType == 1) {
          // templateId
          // if (!!!planType) {
          //   message.warn('请选择运动计划');
          //   return;
          // }
          params.templateId = planType;
        } else {
          // courseId
          // if (!!!selectPlanNo) {
          //   message.warn('请选择运动计划');
          //   return;
          // }
          params.courseId = selectPlanNo;
        }
        params.appointType = 2;
        appointClass({
          requestData: params,
        }).then(({ data, code, msg }) => {
          if (code === '00000') {
            actionRef.current.reload();
            setIsOrderModalVisible(false);
          } else {
            message.error(msg);
          }
        });
      });
    }
  };
  const movePre = () => {
    if (current === 0) {
      // 清空表单
      orderUserForm.resetFields();
      orderCourseForm.resetFields();
      setIsOrderModalVisible(false);
    } else if (current === 1) {
      setSelectPlanNo(undefined);
      setSelectWeekNo(undefined);
      orderCourseForm.resetFields();
      setCurrent(0);
    }
  };

  const btnLeftText = useMemo(() => {
    if (current === 0) {
      return '取消';
    } else if (current === 1) {
      return '上一步';
    }
  }, [current]);

  const btnRightText = useMemo(() => {
    if (current === 0) {
      return '下一步';
    } else if (current === 1) {
      return '确认提交';
    }
  }, [current]);

  useMemo(() => {
    // 时间改变
    if (startTime) {
      const endTime = moment(startTime)
        .add(45, 'minutes')
        .format('YYYY-MM-DD HH:mm:ss');
      queryCoachList({
        requestData: {
          // courseId: xx,//体验课不传
          startClassTime: moment(startTime).format('YYYY-MM-DD HH:mm:ss'),
          endClassTime: endTime,
        },
      }).then(({ data, code, msg }) => {
        if (code === '00000') {
          setPickCoachList(data || []);
        } else {
          message.error(msg);
        }
      });
    }
    // timeChangeHandle(startTime);
  }, [startTime]);

  useMemo(() => {
    // week改变
    // debugger
    if (selectWeekNo) {
      var params = {};
      if (modifyRecord) {
        params = {
          innerUserId: modifyRecord.userId,
          telephone: modifyRecord.userPhone,
          weekNo: selectWeekNo,
        };
      } else {
        params = {
          innerUserId: userId,
          telephone: userPhone,
          weekNo: selectWeekNo,
        };
      }
      getWeeklyCoursesByWeekNo({
        requestData: params,
      }).then(({ data, code, msg }) => {
        if (code === '00000') {
          setPlanList(data || []);
          // TODO:没有的时候如何清空
          if (data?.length > 0) {
            //修改
            if (modifyRecord) {
              var isContains = false;
              data.forEach((e) => {
                if (e.courseId == modifyRecord?.courseId) {
                  isContains = true;
                }
              });

              if (isContains) {
                // 设置选择的
                setSelectPlanNo(modifyRecord?.courseId + '');
              } else {
                setSelectPlanNo(undefined);
              }
            } else {
              setSelectPlanNo(undefined);
              // 新增
              // setSelectPlanNo(data[0]?.courseId);
              // const dataLen = data?.length;
              // if (dataLen > 0) {
              //   //找到第一个可用的
              //   var find = false;
              //   var firstUse;
              //   for (var i = 0; i < dataLen; i++) {
              //     const course = data[i];
              //     if (course.courseStatus >= 0 && course.courseStatus <= 2) {
              //       find = true;
              //       firstUse = course;
              //       break;
              //     }
              //   }
              //   if (find) {
              //     setSelectPlanNo(firstUse?.courseId);
              //   } else {
              //     setSelectPlanNo(undefined);
              //   }
              // }
            }
          }
        }
      });
    }
  }, [selectWeekNo]);

  const [isOrderModalVisible, setIsOrderModalVisible] = useState(false);

  const handleOrderModalCancel = () => {
    orderUserForm.resetFields();
    orderCourseForm.resetFields();
    setCurrent(0);
    setIsOrderModalVisible(false);
  };
  /// 详情弹窗
  const [isDetailModalVisible, setIsDetailModalVisible] = useState(false);
  const handleDetailModalCancel = () => {
    setDetailRecord(undefined);
    setUserAttend(undefined);
    setCoachAttend(undefined);
    setClassList([]);
    setCurrentPageKey('1');
    setIsDetailModalVisible(false);
    setCredibilityActionMetrics([]);
    setCredibilityFrames([]);
    setSelectedCredAction(undefined);
    setSelectedCredMetric(undefined);
    setCredCurrentFrameIndex(0);
    setInFrameThreshold(DEFAULT_IN_FRAME_THRESHOLD);
    setVarianceThreshold(DEFAULT_VARIANCE_THRESHOLD);
  };
  const [detailRecord, setDetailRecord] = useState();
  const [userAttend, setUserAttend] = useState();
  const [coachAttend, setCoachAttend] = useState();
  const [classList, setClassList] = useState();

  // 巡课
  const [inputQRUrl, setInputQRUrl] = useState('');
  const [inputH5Url, setInputH5Url] = useState('');
  const [inputLiveUrl, setInputLiveUrl] = useState('');
  const [isPatrolModalVisible, setIsPatrolModalVisible] = useState(false);

  const AI_CLASS_TYPE = {
    1: { text: 'xplan指导' },
    2: { text: '手动记录' },
    3: { text: '视频跟练' },
  };

  // const handlePatrolModalOk = () => {
  //   setIsPatrolModalVisible(false);
  // };
  const handlePatrolModalCancel = () => {
    setIsPatrolModalVisible(false);
  };
  // 预约
  const order = () => {
    setIsOrderModalVisible(true);
  };
  const detail = (record) => {
    setDetailRecord(record);
    detailRef.current?.reloadAndRest();
    // debugger
    getClassDetail(record);
    getAttend(record);
    getCoachComment(record);
    commentClassAction(record, false);
    setIsDetailModalVisible(true);
    getCompleteClassDetail(record);
    getCompleteClassCommentDetail(record);
  };
  // playback
  const [state, setState] = useState({
    visible: false,
    replaceVideoVisible: false,
    videoPlayVisible: false,
    createModalVisible: false,
    confirmLoading: false,
    // videoPlaySrc: '',
    // xgConfig:{},
  });
  const [xgConfig, setXgConfig] = useState({});
  /// 西瓜播放器
  const [xgPlayer, setXgPlayer] = useState();

  const [currentRoomid, setcurrentRoomid] = useState(undefined);
  const playback = (playbackUrl, record) => {
    setrecord([]);
    setState({
      videoPlayVisible: true,
      // videoPlaySrc: playbackUrl,
    });
    setXgConfig({
      id: 'mse',
      url: playbackUrl,
      autoplay: true,
      playbackRate: [1.0, 2.0, 3.0],
      screenShot: true,
      playsinline: true,
      cssFullscreen: true, // 网页样式全屏
      fluid: true,
      enableContextmenu: true, //右键菜单
      progressDot: [],
    });
    setcurrentRoomid(record.roomId);
    // play();
  };

  const hideVideoPlay = () => {
    setState({ videoPlayVisible: false });
    setXgConfig({
      url: '',
    });
    xgPlayer.destroy(false);
  };

  const columnsMark = [
    {
      title: '时间',
      dataIndex: 'eventTime',
      render: (text) => {
        return formatTime(text / 1000);
      },
    },
    {
      title: '事件类型',
      dataIndex: 'eventType',
      valueEnum: {
        1: { text: '安全确认' },
        2: { text: '点赞' },
        3: { text: '记录' },
      },
    },
    {
      title: '对应动作',
      dataIndex: 'actionName',
    },
    {
      title: '完成情况',
      dataIndex: 'completeStatus',
    },
    {
      title: '截图',
      dataIndex: 'highlightImg',
      render: (text) => {
        // console.log(text == '-');

        return text !== '-' ? <Image width={100} src={text} /> : '--';
      },
    },
  ];

  const [record, setrecord] = useState([]);
  useEffect(() => {
    if (!state.videoPlayVisible) {
      return;
    }
    classEventRecord({
      requestData: { roomId: currentRoomid },
      page: {
        currentPage: 1,
        pageSize: 1000,
      },
    }).then(({ code, msg, data }) => {
      if (code === '00000') {
        setrecord(data);
      } else {
        message.error(msg);
      }
    });
  }, [state]);

  useEffect(() => {
    if (record && xgPlayer && isBeginPlay) {
      record.forEach((item) => {
        const { eventType, eventTime, actionName, completeStatus } = item;
        const displayTime = formatTime(eventTime / 1000);
        // const percent = (eventTime / 1000 / duration) * 100;
        // const percentage = percent + '%';
        const dict = {
          1: { text: '安全确认' },
          2: { text: '点赞' },
          3: { text: '记录' },
        };
        const tipStr =
          displayTime +
          ' ' +
          dict[eventType]?.text +
          ' ' +
          '动作名称：' +
          actionName +
          ' ' +
          '完成情况：' +
          completeStatus;
        const color = eventType === 2 ? 'orange' : 'white';
        console.log('****addProgressDot');
        xgPlayer?.addProgressDot(eventTime / 1000, tipStr, undefined, {
          background: `${color}`,
          color: 'white',
        });
      });
    }
  }, [xgPlayer, record, isBeginPlay]);

  useEffect(() => {
    //修改新增都需要
    //请求体测课模板
    getCourseTemplateList({
      requestData: {},
    }).then(({ data, code, msg }) => {
      if (code == '00000') {
        setTemplateList(data || []);
      } else {
        message.error(msg);
      }
    });

    listReason({
      requestData: {},
    }).then(({ data, code, msg }) => {
      if (code == '00000') {
        setReasonList(data || []);
      } else {
        message.error(msg);
      }
    });

    queryCategories({}).then(({ data, code, msg }) => {
      if (code == '00000') {
        const cache = data?.map((item) => ({
          label: item.categoryName,
          value: item.category,
        }));
        setClassCategoryEnum(cache);
        setClassRoomCategoryList(data);
      } else {
        message.error(msg);
      }
    });
  }, []);

  const renderVideoModal = () => {
    const { videoPlayVisible } = state;
    return (
      <Modal
        //getContainer={false}
        visible={videoPlayVisible}
        width={800}
        title="视频预览"
        maskClosable={false}
        destroyOnClose
        // maskStyle={{ opacity: '0.1', background: '#666666' }}
        onCancel={() => {
          hideVideoPlay();
        }}
        footer={[
          <Button
            onClick={() => {
              hideVideoPlay();
            }}
            key="1"
            type="primary"
          >
            关闭
          </Button>,
        ]}
      >
        <>
          {/* {videoPlayVisible ? (
            <Video
              url={videoPlaySrc}
              controls={true}
              record={record}
              autoPlay
              // style={{ width: '100%', height: '100%' }}
            ></Video>
          ) : (
            ''
          )} */}
          <Xgplayer
            config={xgConfig}
            playerInit={(player) => {
              setXgPlayer(player);
              setPlanType(false);
              player.on('playing', function () {
                //事件名称可以在上述查询
                setTimeout(function () {
                  setBeginPlay(true);
                }, 2000);
              });
            }}
          />

          <ProTable
            columns={columnsMark}
            // actionRef={actionRef}
            request={async (params) => {
              const { data, page, code } = await classEventRecord({
                requestData: { ...params, roomId: currentRoomid },
                page: {
                  currentPage: params.current,
                  pageSize: params.pageSize,
                },
              });
              if (code !== '00000') {
                return {
                  success: false,
                };
              }
              return {
                data: data,
                success: true,
                total: page.count,
              };
            }}
            // columnsState={{
            //   persistenceKey: 'pro-table-singe-demos',
            //   persistenceType: 'localStorage',
            // }}
            rowKey={'eventTime'}
            search={false}
            pagination={{
              defaultPageSize: 5,
            }}
            dateFormatter="string"
          />
        </>
      </Modal>
    );
  };

  //直播
  const [liveVideoPlayVisible, setLiveVideoPlayVisible] = useState(false);
  const [liveVideoPlaySrc, setLiveVideoPlaySrc] = useState('');

  const playLive = (url) => {
    setIsPatrolModalVisible(false);
    if (!!!url) return;
    setLiveVideoPlaySrc(url);
    setLiveVideoPlayVisible(true);
  };

  //请求出勤
  const getAttend = async (record) => {
    let params = { roomNo: record.roomNo, courseId: record.courseId };
    const { data, code, msg } = await getAttendStatus({
      requestData: {
        ...params,
      },
    });
    if (code == '00000') {
      setUserAttend(data?.userAttendStatus);
      setCoachAttend(data?.coachAttendStatus);
    } else {
      message.error(msg);
    }
  };

  //请求教练评语
  const getCoachComment = async (record) => {
    let params = { roomId: record.roomId };
    const { data, code, msg } = await getClassRoom({
      requestData: {
        ...params,
      },
    });
    if (code == '00000') {
      setCommentData(data);
    } else {
      message.error(msg);
    }
  };

  // 总结
  const summarizeClass = async (record) => {
    let params = { roomId: record.roomId };
    const { data, code, msg } = await summarize({
      requestData: {
        ...params,
      },
    });
    if (code == '00000') {
      setCommentData(data);
    } else {
      message.error(msg);
    }
  };

  //请求上课内容
  const getClassDetail = async (record) => {
    let params = { roomNo: record.roomNo, courseId: record.courseId };
    const { data, code, msg } = await queryClassDetailContent({
      requestData: {
        ...params,
      },
    });
    if (code == '00000') {
      setClassList(data || []);
    } else {
      message.error(msg);
    }
  };

  //请求完课内容
  const getCompleteClassDetail = async (record) => {
    let params = { roomId: record.roomId, userId: record.userId };
    // let params = { roomId: 31444, userId: 211116904 };
    const { data, code, msg } = await getCompleteClassInfoForPalmer({
      requestData: {
        ...params,
      },
    });
    if (code == '00000') {
      setCompleteClassInfo(data || {});
    } else {
      message.error(msg);
    }
  };

  //请求完课内容
  const getCompleteClassCommentDetail = async (record) => {
    let params = { roomId: record.roomId, userId: record.userId };
    // let params = { roomId: 31444, userId: 211116904 };
    const { data, code, msg } = await getCompleteActionDetailGptResponse({
      requestData: {
        ...params,
      },
    });
    if (code == '00000') {
      setCompleteClassCommentInfo(data || {});
    } else {
      message.error(msg);
    }
  };

  ///巡课
  const patrol = async (record) => {
    let params = { roomId: record.roomId };
    const { data, code, msg } = await queryClassLiveLink({
      requestData: {
        ...params,
      },
    });
    if (code == '00000') {
      setInputQRUrl(data?.maLink || '');
      setInputH5Url(data?.h5Link || '');
      setInputLiveUrl(data?.liveUrl || '');
      setIsPatrolModalVisible(true);
    } else {
      Message.error(msg);
    }
  };
  //分钟内
  const isMinsIn = (timeMs, mins) => {
    const now = new Date();
    const seconds = moment(timeMs).diff(now, 'seconds');
    //小于0 是到时间 状态还未是已上课 也展示。需要过滤增加条件>0
    return seconds <= mins * 60;
  };

  const qrCodeInputChange = (e) => {
    setInputH5Url(e.target.value);
  };

  const edit = (record) => {
    setModifyRecord(record);
    setModifyVisible(true);
  };

  useMemo(() => {
    if (!!modifyRecord) {
      let bgTime = moment(modifyRecord?.startTime, 'YYYY-MM-DD HH:mm');
      orderModifyForm.setFieldsValue({
        classType: modifyRecord?.classType,
        beginTime: bgTime,
      });
      setStartTime(bgTime);
      //正式课
      if (modifyRecord?.classType == 2) {
        //查询weekNO
        getCoursePlanDetail({
          requestData: {
            courseId: modifyRecord?.courseId,
          },
        }).then(({ data, code, msg }) => {
          const weekNo = data?.weekNo;
          if (code == '00000') {
            //查询计划
            getWeekPerformList({
              requestData: {
                innerUserId: modifyRecord?.userId,
                telephone: modifyRecord?.userPhone,
              },
            }).then(({ data, code, msg }) => {
              if (code == '00000') {
                setWeekPerformList(data || []);
                //触发查询列表  setSelectPlanNo
                setSelectWeekNo(weekNo);
              } else {
                message.error(msg);
              }
            });
          } else {
            message.error(msg);
          }
        });
      } else {
        orderModifyForm.setFieldsValue({
          //回填教练, 可能存在0，的情况  则不显示
          templateId: modifyRecord?.templateId,
        });
      }
      //回填时间&教练
      if (!!modifyRecord?.startTime) {
        const endTime = moment(modifyRecord?.startTime)
          .add(45, 'minutes')
          .format('YYYY-MM-DD HH:mm:ss');
        queryCoachList({
          requestData: {
            // courseId: xx,//体验课不传
            startClassTime: moment(modifyRecord?.startTime).format(
              'YYYY-MM-DD HH:mm:ss',
            ),
            endClassTime: endTime,
          },
        }).then(({ data, code, msg }) => {
          if (code == '00000') {
            setPickCoachList(data || []);
            orderModifyForm.setFieldsValue({
              //回填教练
              coach: modifyRecord?.coachId,
            });
          } else {
            message.error(msg);
          }
        });
      }
    }
  }, [modifyRecord]);

  const cancel = (record) => {
    cancelWarn({
      requestData: {
        roomId: record.roomId,
        channel: 2,
      },
    }).then(({ data, code, msg }) => {
      if (code === '00000') {
        setCancelData(data);
      } else {
        message.error(msg);
      }
    });
    setCancelRecord(record);
    setIsCancelModalVisible(true);
  };

  function blockPlayback(record) {
    shield({
      requestData: {
        roomId: record.roomId,
      },
    }).then(({ data, code, msg }) => {
      if (code === '00000') {
        actionRef.current.reload();

        let record = { ...detailRecord, highlightsBlocked: true };
        setDetailRecord(record);
      } else {
        message.error(msg);
      }
    });
  }

  function releasePlayback(record) {
    unblock({
      requestData: {
        roomId: record.roomId,
      },
    }).then(({ data, code, msg }) => {
      if (code === '00000') {
        actionRef.current.reload();

        let record = { ...detailRecord, highlightsBlocked: false };
        setDetailRecord(record);
      } else {
        message.error(msg);
      }
    });
  }

  const [currentPageKey, setCurrentPageKey] = useState('1');
  const [v3Data, setV3Data] = useState(null);
  const [v3Loading, setV3Loading] = useState(false);
  const onPageChange = (key) => {
    const credibilitySupported =
      detailRecord?.category === 2 &&
      detailRecord?.classInTrainingMethods === 1 &&
      detailRecord?.courseTrainingMethods === 1;
    if (key === '6' && !credibilitySupported) {
      const fallbackKey = credibilitySupported ? '6' : '5';
      setCurrentPageKey(fallbackKey);
    } else {
      setCurrentPageKey(key);
    }
  };

  function range(start, end) {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  }

  function currentDayRange(start, end) {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    result.push(22);
    result.push(23);
    return result;
  }

  // function disabledDateTime() {
  //   return {
  //     disabledHours: () => range(22, 24),
  //     // disabledMinutes: () => range(30, 60),
  //     // disabledSeconds: () => [55, 56],
  //   };
  // }

  const disabledDateTime = (dates) => {
    const currentHours = moment().hours();
    const currentMinutes = moment().minutes();
    const currntSeconds = moment().seconds();
    const currntDates = moment().date();
    if (dates) {
      if (currntDates === dates.date()) {
        let finalHour;
        let finalMinute;
        let finalSeconds;
        if (dates.hour() > currentHours) {
          finalMinute = 0;
        } else {
          finalHour = currentHours;
          finalMinute = currentMinutes;
          finalSeconds = currntSeconds;
        }
        //当天
        return {
          disabledHours: () => currentDayRange(0, finalHour),
          disabledMinutes: () => range(0, finalMinute),
          disabledSeconds: () => range(0, finalSeconds),
        };
      }
      if (moment() > dates) {
        return {
          disabledHours: () => range(0, 24),
          disabledMinutes: () => range(0, 60),
          disabledSeconds: () => range(0, 60),
        };
      }
    } else {
      return {
        disabledHours: () => range(0, 24),
        disabledMinutes: () => range(0, 60),
        disabledSeconds: () => range(0, 60),
      };
    }
    return {
      disabledHours: () => range(22, 24),
    };
  };

  const disabledScopeDate = (time) => {
    if (!time) {
      return false;
    } else {
      // 大于当前日期不能选 time > moment()
      // 小于当前日期不能选 time < moment().subtract(1, "days")
      // 只能选前7后7 time < moment().subtract(7, "days") || time > moment().add(7, 'd')
      // return time < moment().subtract(7, "days") || time > moment().add(7, 'd')
      return (
        time < moment().subtract(1, 'days') || time > moment().add(30, 'd')
      );
    }
  };
  function toRecord(record) {
    window.open(
      `/user/record?id=${record?.userId}&phone=${record?.userPhone}`,
      '_blank',
    );
  }
  const detailColumns = [
    {
      title: '时间',
      dataIndex: 'operateTime',
      key: 'operateTime',
      render: (text, record) => {
        return moment(record.operateTime).format('YYYY-MM-DD HH:mm:ss');
      },
    },
    {
      title: '人员昵称',
      dataIndex: 'personName',
      key: 'personName',
    },
    {
      title: '人员类型',
      dataIndex: 'personType',
      key: 'personType',
      valueEnum: {
        0: { text: '用户' },
        1: { text: '教练' },
        2: { text: '巡课' },
      },
    },
    {
      title: '进出类型',
      dataIndex: 'attendType',
      key: 'attendType',
      valueEnum: {
        0: { text: '进入' },
        1: { text: '离开' },
      },
    },
    {
      title: '上课终端类型',
      dataIndex: 'terminalType',
      key: 'terminalType',
    },
    {
      title: '微信版本号',
      dataIndex: 'wxVersion',
      key: 'wxVersion',
    },
    // {
    //   title: 'IP地址',
    //   dataIndex: 'ipAddress',
    //   hideInSearch: true,
    // },
  ];
  const timeRangeStr = (time) => {
    const day1 = moment(time).isoWeekday(1).format('YYYY-MM-DD');
    const day7 = moment(time).isoWeekday(7).format('YYYY-MM-DD');
    return [day1, day7];
  };
  const columns = [
    {
      title: 'ID',
      key: 'id',
      dataIndex: 'roomId',
      hideInSearch: true,
      width: '80',
    },
    {
      title: '上课时间',
      key: 'dateRange',
      valueType: 'dateRange',
      dataIndex: 'startTime',
      hideInSearch: userRecordInit,
      initialValue: startTimeInit
        ? timeRangeStr(startTimeInit)
        : [
            moment().format('YYYY-MM-DD'),
            moment().add(7, 'day').format('YYYY-MM-DD'),
          ],
      // width: 160,
      render: (val, record) => {
        return (
          <div>
            <div>{val.props.text}</div>
            <div style={{ fontSize: 12, color: 'gray' }}>
              roomNo: {record.roomNo}
            </div>
          </div>
        );
      },
      search: {
        transform: (value) => ({
          startTimeStart: value[0],
          startTimeEnd: value[1],
        }),
      },
    },
    {
      title: '课表名称',
      dataIndex: 'classTypeName',
      key: 'classTypeName',
      hideInSearch: true,
      // width: 150,
      render: (_, record, index, action) => {
        const { category, classInTrainingMethodsDesc } = record;
        // const courseTrainingName = AI_CLASS_TYPE[courseTrainingMethods]?.text;
        return (
          <div>
            <a
              style={{ color: '#333333' }}
              // href={'/action/exclusivePlan/cycle?phone=' + record.userPhone}
              href={`/user/record?id=${record.userId}&phone=${record.userPhone}&tabKey=11`}
              target="_blank"
            >
              <u>{record.title}</u>
            </a>

            <div style={{ fontSize: 12, color: 'gray' }}>
              <span style={{ marginRight: 5 }}>
                {record.trainingMannerDesc}
              </span>
              <Tag color={'orange'}>{getCategoryName(category)}</Tag>
              {classInTrainingMethodsDesc && (
                <Tag color={'green'}>{classInTrainingMethodsDesc}</Tag>
              )}
            </div>
          </div>
        );
      },
    },
    {
      title: '用户手机号',
      dataIndex: 'userPhone',
      key: 'userPhone',
      initialValue: userPhoneInit,
      hideInSearch: userRecordInit,
      hideInTable: true,
    },
    {
      title: '用户微信昵称',
      dataIndex: 'userName',
      key: 'userName',
      hideInSearch: userRecordInit,
      hideInTable: true,
    },
    {
      title: '用户账号',
      dataIndex: 'userName',
      key: 'userName',
      hideInSearch: true,
      render: (_, record, index, action) => {
        return (
          <div
            style={{
              color: '#333333',
              display: 'flex',
              flexDirection: 'column',
              cursor: 'pointer',
            }}
          >
            <u onClick={() => toRecord(record)}>
              <span>{record.userName}</span>
            </u>
            <span
              style={{ fontSize: 12, color: 'gray' }}
              onClick={() => toRecord(record)}
            >
              {record.userPhone}
            </span>
            <span
              style={{ fontSize: 12, color: 'gray' }}
              onClick={() => toRecord(record)}
            >
              userID: {record.userId}
            </span>
          </div>
        );
      },
    },
    {
      title: '预约方式',
      dataIndex: 'appointType',
      key: 'appointType',
      valueType: 'select',
      valueEnum: {
        1: { text: '侧边栏预约' },
        2: { text: '后台预约' },
        3: { text: '一键开课' },
        4: { text: '用户自主约课' },
        5: { text: '服务号约课' },
        6: { text: '定时提醒约课' },
        7: { text: '商家APP创建' },
      },
    },
    {
      title: '创建时间',
      dataIndex: 'ctime',
      key: 'ctime',
      hideInSearch: true,
      render(val, record) {
        return (
          <div>
            {val}
            {record.creatorName && (
              <div style={{ fontSize: 12, color: 'gray' }}>
                创建人：{record.creatorName}
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: '上课老师',
      dataIndex: 'coachName',
      hideInSearch: userRecordInit,
      key: 'coachName',
      render: (_, record, index, action) => {
        return (
          <div>
            <div>{record.coachName}</div>
            {record.category === 2 ? (
              ''
            ) : (
              <div style={{ fontSize: 12, color: 'gray' }}>
                {record.coachPhone}
                <br />
                coachID: {record.coachId}
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: '老师手机号',
      dataIndex: 'coachPhone',
      hideInSearch: userRecordInit,
      key: 'coachPhone',
      hideInTable: true, //只用于搜索
    },
    {
      title: '课表状态',
      dataIndex: 'status',
      key: 'status',
      valueType: 'select',
      // width: 85,
      render: (_, record) => {
        return (
          <div>
            <div>{record.statusName}</div>
            {record.highlightsReady && record?.highlightsBlocked ? (
              <Tag>已拦截回看</Tag>
            ) : (
              ''
            )}
          </div>
        );
      },
      valueEnum: {
        0: { text: '全部' },
        1: { text: '待上课' },
        2: { text: '上课中' },
        3: { text: '已下课' },
        4: { text: '已完课' },
        5: { text: '未上课' },
        6: { text: '旷课' },
        7: { text: '取消' },
        // 8: { text: '待领取' },
        9: { text: '到课热身' },
        10: { text: '到课训练' },
        11: { text: '到课试练' },
      },
      initialValue: classStatusInit,
    },
    {
      title: 'AI课类型',
      dataIndex: 'classInTrainingMethods',
      key: 'classInTrainingMethods',
      valueType: 'select',
      hideInTable: true,
      valueEnum: AI_CLASS_TYPE,
    },
    {
      title: '课程类别',
      dataIndex: 'category',
      key: 'category',
      valueType: 'select',
      hideInTable: true,
      fieldProps: {
        options: classCategoryEnum,
      },
    },
    {
      title: '课表ID',
      key: 'roomId',
      hideInSearch: userRecordInit,
      dataIndex: 'roomId',
      hideInTable: true,
    },
    {
      title: '训练类型',
      dataIndex: 'trainType',
      key: 'trainType',
      valueType: 'select',
      hideInTable: true,
      hideInSearch: userRecordInit,
      valueEnum: {
        // 1: { text: '普通课程' },
        // 2: { text: '私教培训课程' },
        3: { text: '教练自主练习' },
      },
    },
    {
      title: '作业点评',
      dataIndex: 'homeworkStatus',
      key: 'homeworkStatus',
      valueType: 'select',
      render: (_, record) => {
        const { homeworkStatus, category } = record;
        return (
          <div>{category === 2 ? xpCommentEnum?.[homeworkStatus] : '--'}</div>
        );
      },
      valueEnum: {
        1: { text: '未点评' },
        2: { text: '部分点评' },
        3: { text: '已点评' },
      },
    },
    {
      title: '训练方式',
      dataIndex: 'trainingManner',
      key: 'trainingManner',
      valueType: 'select',
      hideInTable: true,
      valueEnum: {
        0: { text: '全部' },
        1: { text: '线上指导' },
        2: { text: '到店指导' },
      },
    },
    {
      title: '操作',
      // dataIndex: '',
      valueType: 'option',
      key: 'option',
      fixed: 'right',
      align: 'center',
      width: '100',
      render: (_, record, index, action) => {
        return (
          <Space direction="vertical">
            {/* {record.status == 4 && record.trainingManner !== 2 ? (
              <a onClick={() => forceClose(record)}>解散房间</a>
            ) : (
              ''
            )} */}
            {/* {!!record.playbackUrl ? (
              <a onClick={() => playback(record.playbackUrl, record)}>回看</a>
            ) : (
              ''
            )} */}
            {record.category === 2 &&
            record.trainingManner !== 2 &&
            record?.homeworkStatus > 1 &&
            (record.status === 9 ||
              record.status === 10 ||
              record.status === 4) ? (
              <a onClick={() => commentClassAction(record)}>作业点评</a>
            ) : (
              ''
            )}
            {record.status == 7 ? (
              <a onClick={() => viewCancelReason(record)}>课程详情</a>
            ) : (
              <a onClick={() => detail(record)}>课程详情</a>
            )}
            {/* {detailModal(record)} */}
            {record.status == 1 &&
            record.trainingManner !== 2 &&
            record.appointType != 3 &&
            record.category !== 2 &&
            record.category !== 3 ? (
              <a onClick={() => edit(record)}>编辑</a>
            ) : (
              ''
            )}

            {/* {modifyModal()} */}
            {/* {record.status == 2 ||
            (record.status == 1 &&
              record.trainingManner !== 2 &&
              isMinsIn(record.startTimeMs, 5)) ? (
              <a onClick={() => patrol(record)}>巡课</a>
            ) : (
              ''
            )} */}
            {/* {patrolModal()} */}
            {record.status == 1 ? (
              <a onClick={() => cancel(record)}>取消</a>
            ) : (
              ''
            )}
            {/* {record.highlightsReady &&
            record?.highlightsBlocked &&
            record.trainingManner !== 2 ? (
              <a onClick={() => releasePlayback(record)}>释放回看</a>
            ) : (
              ''
            )}
            {record.highlightsReady &&
            !record?.highlightsBlocked &&
            record.trainingManner !== 2 ? (
              <a onClick={() => blockPlayback(record)}>拦截回看</a>
            ) : (
              ''
            )} */}
          </Space>
        );
      },
    },
  ];

  const attendTable = () => {
    return (
      <ProTable
        columns={detailColumns}
        actionRef={detailRef}
        request={async (params) => {
          const { data, page, code } = await getCourseAttendRecord({
            requestData: {
              ...params,
              roomNo: detailRecord.roomNo,
              courseId: detailRecord.courseId,
            },
            page: {
              currentPage: params.current,
              pageSize: params.pageSize,
            },
          });
          if (code !== '00000') {
            return {
              success: false,
            };
          }
          return {
            data: data,
            success: true,
            total: page.count,
          };
        }}
        columnsState={{
          persistenceKey: 'pro-table-singe-demos2',
          persistenceType: 'localStorage',
        }}
        rowKey={(record) => record.id}
        search={false}
        pagination={{
          defaultPageSize: 10,
        }}
        dateFormatter="string"
        toolBarRender={false}
      />
    );
  };

  const classDetailDescriptions = () => {
    return (
      <Descriptions
        column={{ sm: 2 }}
        title="课表信息"
        size="small"
        bordered
        key="d1"
      >
        <Descriptions.Item label="开始时间" key="1">
          {detailRecord?.startTime}
        </Descriptions.Item>
        <Descriptions.Item label="上课状态" key="2">
          {detailRecord?.statusName}
        </Descriptions.Item>
        <Descriptions.Item label="上课课节" key="3">
          {detailRecord?.title}
        </Descriptions.Item>
        <Descriptions.Item label="创建时间" key="4">
          {detailRecord?.ctime}
        </Descriptions.Item>
        <Descriptions.Item label="用户账号" key="5">
          {detailRecord?.userName + '(' + detailRecord?.userPhone + ')'}
        </Descriptions.Item>
        <Descriptions.Item label="用户考勤" key="6">
          {userAttend}
        </Descriptions.Item>
        <Descriptions.Item label="上课教练" key="7">
          {detailRecord?.coachName}
        </Descriptions.Item>
        <Descriptions.Item label="教练考勤" key="8">
          {detailRecord?.category === 2 ? '--' : coachAttend}
        </Descriptions.Item>
        <Descriptions.Item label="训练方式" key="9">
          {detailRecord?.trainingMannerDesc}
        </Descriptions.Item>
        <Descriptions.Item label="课程类别" key="10">
          <Tag color={'orange'}>{getCategoryName(detailRecord?.category)}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="课程类型" key="11">
          {detailRecord?.classTypeName}
        </Descriptions.Item>
      </Descriptions>
    );
  };

  const classContentOP = () => {
    return (
      <div style={{ minHeight: 500 }}>
        {classList?.map((e) => (
          <div key={e?.phaseId}>
            <Descriptions
              column={{ sm: 1 }}
              title={e?.phaseName}
              size="small"
              bordered
              key="d2"
            >
              {(e?.coursePhaseActionModelList || []).map((item) => (
                <Descriptions.Item
                  style={{ width: 400 }}
                  label={item.actionName}
                  key={item.actionId}
                >
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    {item.actionGroup}
                    <span style={{ width: 100, textAlign: 'center' }}>
                      {item?.completeStatus ? '已训练' : '/'}
                    </span>
                  </div>
                </Descriptions.Item>
              ))}
            </Descriptions>
            <br />
          </div>
        ))}
      </div>
    );
  };

  const credibilityRequestSeqRef = useRef(0);
  const getCredActionKey = (phaseId, actionId, actionSeqId) =>
    `${phaseId || ''}_${actionId || ''}_${actionSeqId || ''}`;
  const parseRpcData = (response) =>
    response?.result?.data || response?.data || {};
  const toFixedValue = (num) => {
    const value = Number(num);
    return Number.isFinite(value) ? value.toFixed(1) : '--';
  };
  const formatTrainingDuration = (summaryData) => {
    const seconds = summaryData?.reliableTrainingSeconds;
    if (seconds != null && Number.isFinite(Number(seconds))) {
      const total = Math.round(Number(seconds));
      const h = Math.floor(total / 3600);
      const m = Math.floor((total % 3600) / 60);
      const s = total % 60;
      const parts = [];
      if (h > 0) parts.push(`${h} 小时`);
      if (m > 0 || h > 0) parts.push(`${m} 分`);
      if (s > 0) parts.push(`${s} 秒`);
      return parts.length > 0 ? parts.join(' ') : '0 分';
    }
    const mins = Math.round(summaryData?.reliableTrainingMinutes ?? 0);
    return `${mins} 分钟`;
  };
  const normalizeReliabilitySummary = (summaryData, actions) => {
    const actionResults =
      summaryData?.actionResults ||
      summaryData?.actionReliabilitySummaryList ||
      [];
    const summaryMap = {};
    (actionResults || []).forEach((item) => {
      const phaseId = item?.phaseId;
      const actionId = item?.actionId;
      const actionSeqId = item?.actionSeqId;
      if (!phaseId || !actionId || !actionSeqId) return;
      const key = getCredActionKey(phaseId, actionId, actionSeqId);
      summaryMap[key] = item;
    });
    return (actions || []).map((action) => {
      const item = summaryMap[action?.metricKey] || {};
      const aiPass = item?.inFrameResult === true || item?.inFrameResult === 1;
      const bDynPass =
        item?.dynamicVarianceResult === true ||
        item?.dynamicVarianceResult === 1;
      const bStatPass =
        item?.staticPostureResult === true || item?.staticPostureResult === 1;
      const biPass =
        item?.credibleResult === true || item?.credibleResult === 1;
      const validFrames = item?.validFrames ?? item?.inFrameValidFrames ?? 0;
      const totalFrames = item?.totalFrames ?? 0;
      const inFramePct = item?.inFramePercentage ?? item?.inFrameRatio ?? 0;
      return {
        ...action,
        aiPass,
        biPass,
        bDynPass,
        bStatPass,
        pass: biPass,
        inFrameData: {
          result: aiPass ? 1 : 0,
          validFrames,
          totalFrames,
          inFrameRatio: inFramePct,
        },
        varianceData: {
          reliable: bDynPass,
          averageVariance: parseFloat(item?.centroidAvgVariance || 0),
          centroidAvgVariance: parseFloat(item?.centroidAvgVariance || 0),
          upperLimbVariance: parseFloat(item?.upperLimbVariance || 0),
          lowerLimbVariance: parseFloat(item?.lowerLimbVariance || 0),
          varianceThreshold: parseFloat(item?.dynamicVarianceThreshold || 0),
        },
        reliableTrainingSeconds: parseFloat(item?.reliableTrainingSeconds || 0),
        credibleResult: item?.credibleResult,
        inFrameResult: item?.inFrameResult ?? null,
        dynamicVarianceResult: item?.dynamicVarianceResult ?? null,
        staticPostureResult: item?.staticPostureResult ?? null,
        sliceResults: item?.sliceResults || null,
        hasError: false,
      };
    });
  };

  const collectCredibilityActions = () => {
    const allActions = [];
    let order = 1;
    (classList || []).forEach((phase) => {
      (phase?.coursePhaseActionModelList || []).forEach((action) => {
        const actionSeqId = action?.actionSeqId || action?.id;
        if (!phase?.phaseId || !action?.actionId || !actionSeqId) {
          return;
        }
        allActions.push({
          order,
          phaseId: phase?.phaseId,
          phaseName: phase?.phaseName,
          actionId: action?.actionId,
          actionSeqId,
          actionName: action?.actionName,
          completeStatus: action?.completeStatus,
          metricKey: getCredActionKey(
            phase?.phaseId,
            action?.actionId,
            actionSeqId,
          ),
        });
        order += 1;
      });
    });
    return allActions;
  };

  const loadActionKeypoints = async (actionMeta) => {
    const roomId = detailRecord?.roomId;
    const phaseId = actionMeta?.phaseId;
    const actionId = actionMeta?.actionId;
    const actionSeqId = actionMeta?.actionSeqId;
    if (!roomId || !phaseId || !actionId || !actionSeqId) {
      message.warning('动作参数不完整，无法查询骨骼点数据');
      return;
    }

    setSelectedCredAction({
      phaseId,
      actionId,
      actionSeqId,
      phaseName: actionMeta?.phaseName,
      actionName: actionMeta?.actionName,
    });
    setCredibilityLoading(true);
    setCredibilityFrames([]);
    setCredibilityJsonlUrl('');
    setCredibilityJsonlFrames([]);
    setCredCurrentFrameIndex(0);

    try {
      const { code, msg, data } = await classActionKeypointsReview({
        requestData: {
          roomId,
          phaseId,
          actionId,
          actionSeqId,
        },
      });
      if (code === '00000') {
        // 有 JSONL 地址 → KeypointPlayer 直接渲染，不需要前端解析
        if (data?.jsonlKeypointsUrl) {
          setCredibilityJsonlUrl(data.jsonlKeypointsUrl);
        }

        // 兼容老数据：仍然解析 frames 用于序列预览缩略图
        let frames = [];
        if (data?.keypointsUrl) {
          try {
            const resp = await fetch(data.keypointsUrl);
            if (!resp.ok) {
              throw new Error(`HTTP ${resp.status}`);
            }
            const rawFrames = await resp.json();
            frames = (rawFrames || []).map((frame) => ({
              ts: frame.ts,
              d: frame.d,
              keypoints: (frame.k || []).map((pt) => ({
                x: Number(pt.x) * KEYPOINT_SOURCE_WIDTH,
                y: Number(pt.y) * KEYPOINT_SOURCE_HEIGHT,
                score: Number(pt.s),
              })),
            }));
          } catch (urlErr) {
            console.error('获取点位文件失败:', urlErr);
            message.error('获取点位文件失败');
            frames = [];
          }
        } else {
          frames = data?.keypointReview || [];
        }
        setCredibilityFrames(frames);
      } else {
        message.error(msg || '查询骨骼点数据失败');
      }
    } catch (error) {
      message.error('查询骨骼点数据失败');
    } finally {
      setCredibilityLoading(false);
    }
  };

  const loadCredibilityMetrics = async (options = {}) => {
    const roomId = detailRecord?.roomId;
    if (!roomId) {
      return;
    }
    const currentInFrameThreshold =
      options?.inFrameThreshold ??
      inFrameThreshold ??
      DEFAULT_IN_FRAME_THRESHOLD;
    const currentVarianceThreshold =
      options?.varianceThreshold ??
      varianceThreshold ??
      DEFAULT_VARIANCE_THRESHOLD;
    const currentCredibleMinuteThreshold =
      options?.credibleMinuteThreshold ??
      credibleMinuteThreshold ??
      DEFAULT_CREDIBLE_MINUTE_THRESHOLD;
    const currentStaticPostureThreshold =
      (options?.staticConfigThreshold ??
        staticConfigThreshold ??
        DEFAULT_STATIC_CONFIG_THRESHOLD) / 100;
    const actions = collectCredibilityActions();
    if (!actions.length) {
      setCredibilityActionMetrics([]);
      setSelectedCredAction(undefined);
      setCredibilityFrames([]);
      return;
    }
    const requestSeq = Date.now();
    credibilityRequestSeqRef.current = requestSeq;
    setCredibilityMetricsLoading(true);
    setSelectedCredAction(undefined);
    setSelectedCredMetric(undefined);
    setCredibilityFrames([]);
    setCredCurrentFrameIndex(0);

    try {
      const summaryResp = await classActionKeypointsReliabilitySummary({
        requestData: {
          roomId,
          dynamicVarianceThreshold: currentVarianceThreshold,
          inFrameThreshold: currentInFrameThreshold / 100,
          credibleMinutesThreshold: currentCredibleMinuteThreshold,
          staticPostureThreshold: currentStaticPostureThreshold,
        },
      });
      const summaryCode = summaryResp?.result?.code || summaryResp?.code;
      const summaryMsg = summaryResp?.result?.msg || summaryResp?.msg;
      const summaryData = parseRpcData(summaryResp);
      if (summaryCode && summaryCode !== '00000') {
        message.error(summaryMsg || '可信结果计算失败，请稍后重试');
        return;
      }
      const metrics = normalizeReliabilitySummary(summaryData, actions);

      if (credibilityRequestSeqRef.current !== requestSeq) {
        return;
      }
      setCredibilityActionMetrics(metrics);
      setCredibilitySummaryData(parseRpcData(summaryResp) || {});
      const defaultMetric = metrics?.[0];
      setSelectedCredMetric(defaultMetric);
      await loadActionKeypoints(defaultMetric);
    } catch (error) {
      message.error('可信结果计算失败，请稍后重试');
    } finally {
      if (credibilityRequestSeqRef.current === requestSeq) {
        setCredibilityMetricsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (
      !isDetailModalVisible ||
      currentPageKey !== '6' ||
      credibilityFrames.length <= 1
    ) {
      return;
    }
    const timer = setInterval(() => {
      setCredCurrentFrameIndex((prev) => (prev + 1) % credibilityFrames.length);
    }, CREDIBILITY_PLAY_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [isDetailModalVisible, currentPageKey, credibilityFrames]);

  useEffect(() => {
    if (
      !isDetailModalVisible ||
      currentPageKey !== '6' ||
      !detailRecord?.roomId ||
      !classList?.length
    ) {
      return;
    }
    loadCredibilityMetrics();
  }, [isDetailModalVisible, currentPageKey, classList, detailRecord?.roomId]);

  // 动作评估数据加载
  useEffect(() => {
    if (
      !isDetailModalVisible ||
      currentPageKey !== '7' ||
      !detailRecord?.roomId
    ) {
      return;
    }
    const roomId = detailRecord.roomId;
    setV3Loading(true);
    v3AnalysisDetail({ requestData: { roomId } })
      .then((resp) => {
        const code = resp?.result?.code || resp?.code;
        const data = resp?.result?.data || resp?.data;
        if (code === '00000') {
          setV3Data(data || null);
        } else {
          setV3Data(null);
        }
      })
      .catch(() => {
        setV3Data(null);
      })
      .finally(() => {
        setV3Loading(false);
      });
  }, [isDetailModalVisible, currentPageKey, detailRecord?.roomId]);

  // 解析 JSONL 序列数据用于序列预览
  useEffect(() => {
    if (!credibilityJsonlUrl) {
      setCredibilityJsonlFrames([]);
      return;
    }
    fetch(credibilityJsonlUrl)
      .then((res) => res.text())
      .then((text) => {
        const lines = text.trim().split('\n');
        let sourceWidth = 1;
        let sourceHeight = 1;
        const frames = [];

        for (const line of lines) {
          if (!line.trim()) continue;
          let obj;
          try {
            obj = JSON.parse(line);
          } catch {
            continue;
          }
          if (obj.type === 'metadata') {
            const v = obj.source || obj.video || {};
            if (v.width) sourceWidth = v.width;
            if (v.height) sourceHeight = v.height;
          } else if (obj.type === 'frame' || obj.frameIndex !== undefined) {
            const rawKeypoints = Array.isArray(obj.keypoints)
              ? obj.keypoints
              : [];
            const keypoints = rawKeypoints.map((kp) => ({
              x: ((kp[0] ?? 0) / sourceWidth) * KEYPOINT_SOURCE_WIDTH,
              y: ((kp[1] ?? 0) / sourceHeight) * KEYPOINT_SOURCE_HEIGHT,
              score: kp[2] ?? 1.0,
            }));
            frames.push({
              ts: obj.ts ?? 0,
              frameIndex: obj.frameIndex ?? 0,
              keypoints,
            });
          }
        }

        frames.sort((a, b) => a.frameIndex - b.frameIndex);
        setCredibilityJsonlFrames(frames);
      })
      .catch((err) => {
        console.error('解析 JSONL 序列数据失败:', err);
        setCredibilityJsonlFrames([]);
      });
  }, [credibilityJsonlUrl]);

  const credibilityTotalFrames = credibilityFrames?.length || 0;
  const credibilityCurrentFrame =
    credibilityTotalFrames > 0
      ? credibilityFrames[credCurrentFrameIndex]
      : undefined;
  const totalActionCount = (credibilityActionMetrics || []).length;

  const credibilityTab = () => {
    const selectedMetricKey = selectedCredMetric?.metricKey;
    const selectedMetricCanReplay = Boolean(selectedCredMetric?.pass);
    const handleActionMetricSelect = async (metric) => {
      if (!metric) {
        return;
      }
      setSelectedCredMetric(metric);
      await loadActionKeypoints(metric);
    };
    const onInFrameThresholdChange = (value) => {
      if (!Number.isFinite(value)) {
        return;
      }
      setInFrameThreshold(value);
      loadCredibilityMetrics({ inFrameThreshold: value });
    };
    const onVarianceThresholdChange = (value) => {
      if (!Number.isFinite(value)) {
        return;
      }
      setVarianceThreshold(value);
      loadCredibilityMetrics({ varianceThreshold: value });
    };
    const onCredibleMinuteChange = (value) => {
      if (!Number.isFinite(value)) return;
      setCredibleMinuteThreshold(value);
      loadCredibilityMetrics({ credibleMinuteThreshold: value });
    };
    const onStaticConfigChange = (value) => {
      if (!Number.isFinite(value)) return;
      setStaticConfigThreshold(value);
      loadCredibilityMetrics({ staticConfigThreshold: value });
    };

    return (
      <div style={{ minHeight: 520 }}>
        <div style={{ display: 'flex', gap: 12 }}>
          <div
            style={{
              width: 260,
              minWidth: 260,
              borderRight: '1px solid #f0f0f0',
              paddingRight: 10,
            }}
          >
            <Title level={5}>参数设置</Title>
            <div
              style={{
                marginBottom: 16,
                padding: '10px 12px',
                border: '1px solid #e8e8e8',
                borderRadius: 6,
              }}
            >
              <div style={{ fontWeight: 500, marginBottom: 10, color: '#333' }}>
                入镜与时长阈值
              </div>
              <div style={{ marginBottom: 12 }}>
                <div style={{ marginBottom: 4 }}>
                  入镜比例阈值: <Tag color="blue">{inFrameThreshold}%</Tag>
                </div>
                <Slider
                  min={10}
                  max={100}
                  value={inFrameThreshold}
                  onChange={setInFrameThreshold}
                  onAfterChange={onInFrameThresholdChange}
                />
              </div>
              <div>
                <div style={{ marginBottom: 4 }}>
                  有效时长阈值:{' '}
                  <Tag color="orange">{credibleMinuteThreshold}分钟</Tag>
                </div>
                <Slider
                  min={5}
                  max={60}
                  value={credibleMinuteThreshold}
                  onChange={setCredibleMinuteThreshold}
                  onAfterChange={onCredibleMinuteChange}
                />
              </div>
            </div>
            <div
              style={{
                marginBottom: 0,
                padding: '10px 12px',
                border: '1px solid #e8e8e8',
                borderRadius: 6,
              }}
            >
              <div style={{ fontWeight: 500, marginBottom: 10, color: '#333' }}>
                动态与静态阈值
              </div>
              <div style={{ marginBottom: 12 }}>
                <div style={{ marginBottom: 4 }}>
                  动态方差阈值: <Tag color="purple">{varianceThreshold}</Tag>
                </div>
                <Slider
                  min={5}
                  max={50}
                  value={varianceThreshold}
                  onChange={setVarianceThreshold}
                  onAfterChange={onVarianceThresholdChange}
                />
              </div>
              <div>
                <div style={{ marginBottom: 4 }}>
                  静态构型阈值: <Tag color="cyan">{staticConfigThreshold}%</Tag>
                </div>
                <Slider
                  min={10}
                  max={100}
                  value={staticConfigThreshold}
                  onChange={setStaticConfigThreshold}
                  onAfterChange={onStaticConfigChange}
                />
              </div>
            </div>
          </div>

          <div style={{ flex: 1 }}>
            <Title level={5}>课程可信概览</Title>
            <div
              style={{
                border: '1px solid #f0f0f0',
                borderRadius: 8,
                padding: '6px 10px 10px',
                marginBottom: 12,
                overflow: 'hidden',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 8,
                  padding: '6px 12px',
                  background: '#fafafa',
                  borderRadius: 6,
                  fontSize: 13,
                }}
              >
                <span style={{ color: '#888' }}>
                  共 <b style={{ color: '#333' }}>{totalActionCount}</b> 个动作 · 可信训练时长{' '}
                  <b style={{ color: '#fa8c16' }}>
                    {formatTrainingDuration(credibilitySummaryData)}
                  </b>
                </span>
                <Tag
                  color={credibilitySummaryData?.overallReliable ? 'green' : 'red'}
                  style={{ fontSize: 13, padding: '1px 10px', margin: 0 }}
                >
                  {credibilitySummaryData?.overallReliable ? '达标' : '未达标'}
                </Tag>
              </div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: `repeat(${Math.max(
                    totalActionCount,
                    1,
                  )}, minmax(0, 1fr))`,
                  alignItems: 'end',
                  gap: 4,
                }}
              >
                {(credibilityActionMetrics || []).map((metric) => {
                  const isSelected = selectedMetricKey === metric?.metricKey;
                  const hasSlices =
                    metric?.sliceResults && metric.sliceResults.length > 0;
                  const BAR_HEIGHT = 120;
                  let credibleRatio = 0;
                  if (hasSlices) {
                    const totalDuration = metric.sliceResults.reduce(
                      (sum, s) => sum + (s.duration || 0),
                      0,
                    );
                    const credibleDuration = metric.sliceResults.reduce(
                      (sum, s) =>
                        sum + (s.credibleResult ? s.duration || 0 : 0),
                      0,
                    );
                    credibleRatio =
                      totalDuration > 0 ? credibleDuration / totalDuration : 0;
                  } else {
                    credibleRatio = metric?.pass ? 1 : 0;
                  }
                  return (
                    <div
                      key={metric?.metricKey}
                      onClick={() => handleActionMetricSelect(metric)}
                      style={{
                        cursor: 'pointer',
                        textAlign: 'center',
                        userSelect: 'none',
                      }}
                    >
                      <div
                        style={{
                          position: 'relative',
                          height: BAR_HEIGHT,
                          background: '#ff4d4f',
                          borderRadius: 4,
                          border: isSelected
                            ? '2px solid #1890ff'
                            : '1px solid rgba(0, 0, 0, 0.06)',
                          opacity: isSelected ? 1 : 0.85,
                          overflow: 'hidden',
                        }}
                      >
                        <div
                          style={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            height: `${Math.round(credibleRatio * BAR_HEIGHT)}px`,
                            background: '#52c41a',
                          }}
                        />
                      </div>
                      <div style={{ marginTop: 4, fontSize: 11 }}>
                        {metric?.order}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div style={{ marginBottom: 12 }}>
              <Title level={5}>动作详情</Title>
              {selectedCredMetric ? (
                <div
                  style={{
                    border: '1px solid #f0f0f0',
                    borderRadius: 8,
                    padding: 10,
                  }}
                >
                  <div style={{ marginBottom: 8 }}>
                    <Tag color="blue">
                      {selectedCredMetric?.phaseName || '-'}
                    </Tag>
                    <Tag color={selectedMetricCanReplay ? 'green' : 'red'}>
                      {selectedCredMetric?.actionName || '-'}
                    </Tag>
                    <Tag color="orange">
                      可信时长:{' '}
                      {Math.round(
                        selectedCredMetric?.reliableTrainingSeconds ?? 0,
                      )}
                      秒
                    </Tag>
                  </div>

                  {(selectedCredMetric?.sliceResults?.length > 0) && (
                    <div style={{ marginBottom: 12 }}>
                      <div
                        style={{
                          fontSize: 13,
                          fontWeight: 500,
                          color: '#333',
                          marginBottom: 6,
                        }}
                      >
                        时间分片明细
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          height: 20,
                          borderRadius: 4,
                          overflow: 'hidden',
                          border: '1px solid #e8e8e8',
                          marginBottom: 10,
                        }}
                      >
                        {selectedCredMetric.sliceResults.map((slice) => {
                          const pct =
                            (slice.duration /
                              selectedCredMetric.sliceResults.reduce(
                                (sum, s) => sum + (s.duration || 0),
                                0,
                              )) *
                            100;
                          return (
                            <Tooltip
                              key={slice.sliceIndex}
                              title={`${slice.startTime.toFixed(1)}s – ${slice.endTime.toFixed(1)}s（${slice.duration.toFixed(1)}s）`}
                            >
                              <div
                                style={{
                                  width: `${pct}%`,
                                  background: slice.credibleResult
                                    ? '#52c41a'
                                    : '#ff4d4f',
                                  height: '100%',
                                  cursor: 'pointer',
                                }}
                              />
                            </Tooltip>
                          );
                        })}
                      </div>
                      <div
                        style={{
                          border: '1px solid #f0f0f0',
                          borderRadius: 6,
                          overflow: 'hidden',
                        }}
                      >
                        <div
                          style={{
                            display: 'grid',
                            gridTemplateColumns: '110px 72px 72px 80px 80px 80px 90px',
                            background: '#fafafa',
                            borderBottom: '1px solid #f0f0f0',
                            fontSize: 12,
                            fontWeight: 500,
                            color: '#666',
                          }}
                        >
                          <div style={{ padding: '6px 8px', borderRight: '1px solid #f0f0f0' }}>时间</div>
                          <div style={{ padding: '6px 8px', borderRight: '1px solid #f0f0f0', textAlign: 'center' }}>可信结果</div>
                          <div style={{ padding: '6px 8px', borderRight: '1px solid #f0f0f0', textAlign: 'center' }}>入镜</div>
                          <div style={{ padding: '6px 8px', borderRight: '1px solid #f0f0f0', textAlign: 'center' }}>
                            <Tooltip title="动态方差判定：基于动作执行过程中的姿态稳定性，采用质心、上肢和下肢的联合方差进行计算。">
                              <span style={{ borderBottom: '1px dashed #999', cursor: 'help' }}>动态有效性</span>
                            </Tooltip>
                          </div>
                          <div style={{ padding: '6px 8px', borderRight: '1px solid #f0f0f0', textAlign: 'center' }}>
                            <Tooltip title="静态构型判定：基于采集的点位与动作标准的匹配度进行计算。">
                              <span style={{ borderBottom: '1px dashed #999', cursor: 'help' }}>静态有效性</span>
                            </Tooltip>
                          </div>
                          <div style={{ padding: '6px 8px', borderRight: '1px solid #f0f0f0', textAlign: 'center' }}>质心方差</div>
                          <div style={{ padding: '6px 8px', textAlign: 'center' }}>入镜比例</div>
                        </div>
                        {selectedCredMetric.sliceResults.map((slice, idx) => {
                          const sliceAiPass = slice.inFrameResult === true || slice.inFrameResult === 1;
                          const sliceDynPass = slice.dynamicVarianceResult === true || slice.dynamicVarianceResult === 1;
                          const sliceStatPass = slice.staticPostureResult === true || slice.staticPostureResult === 1;
                          const sliceBiPass = slice.credibleResult === true || slice.credibleResult === 1;
                          return (
                            <div
                              key={slice.sliceIndex}
                              style={{
                                display: 'grid',
                                gridTemplateColumns: '110px 72px 72px 80px 80px 80px 90px',
                                borderBottom: idx < selectedCredMetric.sliceResults.length - 1 ? '1px solid #f0f0f0' : 'none',
                                fontSize: 12,
                              }}
                            >
                              <div style={{ padding: '6px 8px', borderRight: '1px solid #f0f0f0', color: '#555', whiteSpace: 'nowrap' }}>
                                {slice.startTime.toFixed(1)}–{slice.endTime.toFixed(1)}s
                              </div>
                              <div style={{ padding: '6px 8px', borderRight: '1px solid #f0f0f0', textAlign: 'center' }}>
                                <Tag color={sliceBiPass ? 'green' : 'red'} style={{ fontSize: 11, margin: 0 }}>
                                  {sliceBiPass ? '可信' : '不可信'}
                                </Tag>
                              </div>
                              <div style={{ padding: '6px 8px', borderRight: '1px solid #f0f0f0', textAlign: 'center' }}>
                                <Tag color={sliceAiPass ? 'green' : 'red'} style={{ fontSize: 11, margin: 0 }}>
                                  {sliceAiPass ? '有效' : '无效'}
                                </Tag>
                              </div>
                              <div style={{ padding: '6px 8px', borderRight: '1px solid #f0f0f0', textAlign: 'center' }}>
                                <Tag color={sliceDynPass ? 'green' : 'red'} style={{ fontSize: 11, margin: 0 }}>
                                  {sliceDynPass ? '有效' : '无效'}
                                </Tag>
                              </div>
                              <div style={{ padding: '6px 8px', borderRight: '1px solid #f0f0f0', textAlign: 'center' }}>
                                <Tag color={sliceStatPass ? 'green' : 'red'} style={{ fontSize: 11, margin: 0 }}>
                                  {sliceStatPass ? '有效' : '无效'}
                                </Tag>
                              </div>
                              <div style={{ padding: '6px 8px', borderRight: '1px solid #f0f0f0', textAlign: 'center', color: '#666' }}>
                                {toFixedValue(slice.centroidAvgVariance)}
                              </div>
                              <div style={{ padding: '6px 8px', textAlign: 'center', color: '#666', whiteSpace: 'nowrap' }}>
                                {slice.inFramePercentage ?? 0}%
                                <span style={{ color: '#999', marginLeft: 2 }}>
                                  ({slice.validFrames ?? 0}/{slice.totalFrames ?? 0})
                                </span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {!(selectedCredMetric?.inFrameResult == null &&
                    selectedCredMetric?.dynamicVarianceResult == null &&
                    selectedCredMetric?.staticPostureResult == null) && (
                  <>
                  <div style={{ marginBottom: 8 }}>
                    <Space wrap size={4}>
                      <Tag color={selectedCredMetric?.aiPass ? 'green' : 'red'}>
                        A<sub>i</sub>:{' '}
                        {selectedCredMetric?.aiPass ? '有效' : '无效'}（
                        {selectedCredMetric?.inFrameData?.inFrameRatio ?? 0}%)
                      </Tag>
                      <Tooltip title="入镜判定：基于用户在动作过程中保持在画面中的比例进行计算。">
                        <QuestionCircleOutlined
                          style={{
                            color: '#999',
                            cursor: 'pointer',
                            fontSize: 14,
                            marginLeft: -5,
                            marginRight: 10,
                          }}
                        />
                      </Tooltip>
                      <Tag
                        color={selectedCredMetric?.bDynPass ? 'green' : 'red'}
                      >
                        B<sub>dyn</sub>:{' '}
                        {selectedCredMetric?.bDynPass ? '达标' : '不达标'}
                      </Tag>
                      <Tooltip title="动态方差判定：基于动作执行过程中的姿态稳定性，采用质心、上肢和下肢的联合方差进行计算。">
                        <QuestionCircleOutlined
                          style={{
                            color: '#999',
                            cursor: 'pointer',
                            fontSize: 14,
                            marginLeft: -5,
                            marginRight: 10,
                          }}
                        />
                      </Tooltip>
                      <Tag
                        color={selectedCredMetric?.bStatPass ? 'green' : 'red'}
                      >
                        B<sub>stat</sub>:{' '}
                        {selectedCredMetric?.bStatPass ? '达标' : '不达标'}
                      </Tag>
                      <Tooltip title="静态构型判定：基于采集的点位与动作标准的匹配度进行计算。">
                        <QuestionCircleOutlined
                          style={{
                            color: '#999',
                            cursor: 'pointer',
                            fontSize: 14,
                            marginLeft: -5,
                            marginRight: 10,
                          }}
                        />
                      </Tooltip>
                      <Tag color={selectedCredMetric?.biPass ? 'green' : 'red'}>
                        B<sub>i</sub>:{' '}
                        {selectedCredMetric?.biPass ? '有效' : '无效'}
                      </Tag>
                      <Tooltip
                        title={
                          <div>
                            <div style={{ fontWeight: 500, marginBottom: 4 }}>
                              动作有效性说明：
                            </div>
                            <div>
                              当动态有效性（B<sub>dyn</sub>）或静态有效性（B
                              <sub>stat</sub>）任意一个达标时，该动作即为有效。
                            </div>
                            <div style={{ marginTop: 4, color: '#ffd591' }}>
                              B<sub>i</sub> = max(B<sub>dyn</sub>, B
                              <sub>stat</sub>)
                            </div>
                          </div>
                        }
                      >
                        <QuestionCircleOutlined
                          style={{
                            color: '#999',
                            cursor: 'pointer',
                            fontSize: 14,
                            marginLeft: -5,
                          }}
                        />
                      </Tooltip>
                    </Space>
                  </div>
                  <div>
                    <Space wrap size={8}>
                      <Tag>
                        有效帧:{' '}
                        {selectedCredMetric?.inFrameData?.validFrames ?? '--'}/
                        {selectedCredMetric?.inFrameData?.totalFrames ?? '--'}
                      </Tag>
                      <Tag>
                        质心方差:{' '}
                        {toFixedValue(
                          selectedCredMetric?.varianceData?.centroidAvgVariance,
                        )}
                      </Tag>
                      <Tag>
                        上肢方差:{' '}
                        {toFixedValue(
                          selectedCredMetric?.varianceData?.upperLimbVariance,
                        )}
                      </Tag>
                      <Tag>
                        下肢方差:{' '}
                        {toFixedValue(
                          selectedCredMetric?.varianceData?.lowerLimbVariance,
                        )}
                      </Tag>
                    </Space>
                  </div>
                  </>
                  )}
                </div>
              ) : (
                <div style={{ color: '#999' }}>
                  点击上方柱状图中的动作查看详情
                </div>
              )}
            </div>

            {credibilityFrames.length > 0 ||
            credibilityJsonlFrames.length > 0 ? (
              <div>
                <Title level={5}>动作回放</Title>
                <div
                  style={{
                    border: '1px solid #e8e8e8',
                    borderRadius: 8,
                  }}
                >
                    {credibilityJsonlUrl ? (
                      <div style={{ width: '100%', height: 260 }}>
                        <KeypointPlayer
                          ref={keypointPlayerRef}
                          dataUrl={credibilityJsonlUrl}
                          loop={true}
                          autoPlay={true}
                          onlyShow={true}
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          background: '#0f172a',
                          borderRadius: 8,
                          padding: 12,
                        }}
                      >
                        <KeypointCanvas
                          keypoints={credibilityCurrentFrame?.keypoints || []}
                          canvasWidth={KEYPOINT_PLAYER_WIDTH}
                          canvasHeight={KEYPOINT_PLAYER_HEIGHT}
                          pointRadius={3}
                          enableSmoothing={true}
                        />
                        <div
                          style={{
                            marginTop: 8,
                            color: '#d9d9d9',
                            display: 'flex',
                            justifyContent: 'space-between',
                            fontSize: 12,
                          }}
                        >
                          <span>
                            {credibilityCurrentFrame?.ts
                              ? moment(credibilityCurrentFrame.ts).format(
                                  'YYYY-MM-DD HH:mm:ss.SSS',
                                )
                              : '--'}
                          </span>
                          <span>
                            FRAME {credCurrentFrameIndex + 1}/
                            {credibilityTotalFrames || 0}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
              selectedCredMetric && (
                <div style={{ color: '#999', marginTop: 4 }}>
                  暂无数据，无法展示动作回放
                </div>
              )
            )}

            {credibilityLoading && (
              <div style={{ marginTop: 12, color: '#999' }}>
                回放数据加载中...
              </div>
            )}
            {credibilityMetricsLoading && (
              <div style={{ marginTop: 12, color: '#999' }}>
                动作可信结果计算中...
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const classListItemView = () => {
    return (
      <div>
        <Paragraph>
          <blockquote style={{ borderColor: 'skyblue' }}>纬度评分</blockquote>
        </Paragraph>
        <Descriptions>
          <Descriptions.Item label="上肢灵活性">
            {commentData?.fitnessScoreModel?.flexibleUpperlimb ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item label="下肢灵活性">
            {commentData?.fitnessScoreModel?.flexibleLowerlimb ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item label="上肢力量">
            {commentData?.fitnessScoreModel?.powerUpperlimb ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item label="下肢力量">
            {commentData?.fitnessScoreModel?.powerLowerlimb ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item label="胸椎灵活性">
            {commentData?.fitnessScoreModel?.flexibleThoracic ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item label="躯干稳定性">
            {commentData?.fitnessScoreModel?.stableTrunk ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item label="上肢稳定性">
            {commentData?.fitnessScoreModel?.stableUpperlimb ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item label="下肢稳定性">
            {commentData?.fitnessScoreModel?.stableLowerlimb ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item label="心肺功能">
            {commentData?.fitnessScoreModel?.heartLung ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item label="认知协调">
            {commentData?.fitnessScoreModel?.coordinate ?? '-'}
          </Descriptions.Item>
        </Descriptions>

        <Paragraph>
          <blockquote style={{ borderColor: 'skyblue' }}>上课照片</blockquote>
        </Paragraph>
        {commentData?.highlightResponseList?.length > 0 ? (
          <Row gutter={[8, 8]}>
            {commentData?.highlightResponseList?.map((e) => {
              return (
                <Col span={4} key={e?.highlightImg}>
                  <Image
                    width={160}
                    key={e?.highlightImg}
                    src={e?.highlightImg}
                  />
                </Col>
              );
            })}
          </Row>
        ) : (
          '暂无'
        )}

        <Paragraph>
          <blockquote style={{ borderColor: 'skyblue' }}>教练评语</blockquote>
          <pre>{commentData?.coachComment ?? '-'}</pre>
        </Paragraph>
      </div>
    );
  };

  const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  const orderFormItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 },
  };
  const cancelFormItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 18 },
  };
  ///预约弹窗
  const orderModal = () => {
    return (
      <div>
        <Modal
          //getContainer={false}
          title={'预约上课'}
          width={800}
          visible={isOrderModalVisible}
          onCancel={handleOrderModalCancel}
          footer={[]}
        >
          <Steps current={current}>
            <Step key="step0" />
            <Step key="step1" />
          </Steps>
          <br />
          <br />
          <br />
          {current == 0 && (
            <div style={{ display: current === 0 ? 'block' : 'none' }}>
              <Form
                form={orderUserForm}
                {...orderFormItemLayout}
                name={'order0'}
              >
                <Form.Item
                  label={'选择用户'}
                  name={'telephone'}
                  rules={[
                    {
                      required: true,
                      message: '请选择',
                    },
                  ]}
                >
                  <Input placeholder="请输入手机号" maxLength={11} allowClear />
                </Form.Item>

                <Form.Item
                  label={'上课类型'}
                  name={'classType'}
                  onChange={onClassTypeChange}
                  rules={[
                    {
                      required: true,
                      message: '请选择',
                    },
                  ]}
                >
                  <Radio.Group>
                    <Radio value={1}>体测课</Radio>
                    <Radio value={2}>正式课</Radio>
                  </Radio.Group>
                </Form.Item>
              </Form>
            </div>
          )}

          {current == 1 && (
            <div style={{ display: current == 1 ? 'block' : 'none' }}>
              <Form form={orderCourseForm} {...formItemLayout} name={'order'}>
                <Form.Item label={'上课用户'}>
                  <label>
                    {userPhone}({userName})
                  </label>
                </Form.Item>

                <Form.Item label={'上课类型'}>
                  <label>{classType == 1 ? '体测课' : '正式课'}</label>
                </Form.Item>

                <Form.Item
                  hidden={classType == 2}
                  label={
                    <span>
                      <span style={{ color: 'red' }}></span> 运动计划
                    </span>
                  }
                >
                  <Select
                    style={{ width: '352px' }}
                    placeholder="请输入"
                    optionFilterProp="children"
                    onChange={onPlanTypeChange}
                    allowClear
                  >
                    {templateList.map((item) => (
                      <Select.Option
                        value={item.templateId}
                        key={item.templateId?.toString()}
                      >
                        {item.templateName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  hidden={classType == 1}
                  label={
                    <span>
                      <span style={{ color: 'red' }}></span> 运动计划
                    </span>
                  }
                >
                  <Select
                    style={{ width: 200 }}
                    placeholder="请输入"
                    optionFilterProp="children"
                    onChange={onWeekNoChange}
                    allowClear
                  >
                    {weekPerformList.map((item) => (
                      <Select.Option
                        value={item.weekNo}
                        key={item.weekNo?.toString()}
                      >
                        第{item.weekNo}周训练计划
                      </Select.Option>
                    ))}
                  </Select>
                  <Select
                    style={{ width: 200 }}
                    onChange={onPlanChange}
                    placeholder="请输入"
                    optionFilterProp="children"
                    value={selectPlanNo}
                    allowClear
                  >
                    {planList.map((item) => (
                      <Select.Option
                        value={item.courseId}
                        key={item.courseId?.toString()}
                        // disabled={
                        //   !(item?.courseStatus >= 0 && item?.courseStatus <= 2)
                        // }
                      >
                        {item.courseName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  label={'上课时间'}
                  name={'beginTime'}
                  rules={[
                    {
                      required: true,
                      message: '请选择',
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: '352px' }}
                    disabledDate={disabledScopeDate}
                    disabledTime={disabledDateTime}
                    showTime={{ format: 'HH:mm' }}
                    format="YYYY-MM-DD HH:mm"
                    minuteStep={5}
                    onOk={onOk}
                  />
                </Form.Item>

                <Form.Item
                  label={'选择教练'}
                  name={'coach'}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: '请选择',
                  //   },
                  // ]}
                >
                  <Select
                    style={{ width: '352px' }}
                    placeholder="请输入"
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                    allowClear
                  >
                    {pickCoachList.map((item) => (
                      <Select.Option
                        value={item.coachId}
                        key={item.coachId?.toString()}
                      >
                        {getCoachStr(item)}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Form>
            </div>
          )}

          <div style={{ textAlign: 'center' }}>
            <Space>
              <Button onClick={movePre} type="primary">
                {btnLeftText}
              </Button>
              <Button onClick={moveNext} type="primary">
                {btnRightText}
              </Button>
            </Space>
          </div>
        </Modal>
      </div>
    );
  };

  //查看弹窗
  const modifyModal = () => {
    return (
      <div>
        <Modal
          //getContainer={false}
          title={'修改'}
          width={1000}
          visible={modifyVisible}
          // confirmLoading={loading}
          // maskStyle={{ opacity: '0.1', background: '#666666' }}
          onOk={handleModifyModalOk}
          onCancel={handleModifyModalCancel}
        >
          <Form
            form={orderModifyForm}
            {...formItemLayout}
            name={'orderModifyForm'}
          >
            <Form.Item label={'上课用户'}>
              <label>
                {modifyRecord?.userPhone}({modifyRecord?.userName})
              </label>
            </Form.Item>

            <Form.Item
              label={'上课类型'}
              name="classType"
              rules={[
                {
                  required: true,
                  message: '请选择',
                },
              ]}
            >
              <Radio.Group disabled>
                <Radio value={1}>体测课</Radio>
                <Radio value={2}>正式课</Radio>
              </Radio.Group>
            </Form.Item>

            {/* 修改时参数异常也隐藏, 以前的数据可能为0 */}
            <Form.Item
              hidden={
                modifyRecord?.classType == 2 ||
                !hasTemplateId(modifyRecord?.templateId)
              }
              name="templateId"
              label={
                <span>
                  <span style={{ color: 'red' }}></span> 运动计划
                </span>
              }
            >
              <Select
                style={{ width: '352px' }}
                placeholder="请输入"
                allowClear
              >
                {templateList.map((item) => (
                  <Select.Option
                    value={item.templateId}
                    key={item.templateId?.toString()}
                  >
                    {item.templateName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              hidden={modifyRecord?.classType == 1}
              label={
                <span>
                  <span style={{ color: 'red' }}></span> 运动计划
                </span>
              }
            >
              <Select
                style={{ width: 200 }}
                placeholder="请输入"
                optionFilterProp="children"
                value={selectWeekNo}
                onChange={onWeekNoChange}
                // disabled={true}
                allowClear
                // onChange={onWeekNoChange}
              >
                {weekPerformList.map((item) => (
                  <Select.Option
                    value={item.weekNo}
                    key={item.weekNo?.toString()}
                  >
                    第{item.weekNo}周训练计划
                  </Select.Option>
                ))}
              </Select>
              <Select
                style={{ width: 200 }}
                onChange={onPlanChange}
                placeholder="请输入"
                optionFilterProp="children"
                value={selectPlanNo}
                // disabled={true}
                allowClear
              >
                {planList.map((item) => (
                  <Select.Option
                    value={item.courseId}
                    key={item.courseId}
                    // disabled={item?.courseStatus != 0}
                  >
                    {item.courseName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label={'上课时间'}
              name={'beginTime'}
              rules={[
                {
                  required: true,
                  message: '请选择',
                },
              ]}
            >
              <DatePicker
                style={{ width: '352px' }}
                disabledDate={disabledScopeDate}
                disabledTime={disabledDateTime}
                showTime={{ format: 'HH:mm' }}
                format="YYYY-MM-DD HH:mm"
                minuteStep={5}
                onOk={onOk}
              />
            </Form.Item>

            <Form.Item
              // label={'选择教练'}
              name={'coach'}
              // rules={[
              //   {
              //     required: true,
              //     message: '请选择',
              //   },
              // ]}
              label={
                <span>
                  <span style={{ color: 'red' }}></span> 选择教练
                </span>
              }
            >
              <Select
                style={{ width: '352px' }}
                placeholder="请输入"
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                filterSort={(optionA, optionB) =>
                  optionA.children
                    .toLowerCase()
                    .localeCompare(optionB.children.toLowerCase())
                }
              >
                {pickCoachList.map((item) => (
                  <Select.Option
                    value={item.coachId}
                    key={item.coachId?.toString()}
                  >
                    {getCoachStr(item)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  };
  const goPreview = (url) => {
    if (!url) {
      return;
    }
    setLiveVideoPlaySrc(url);
    setLiveVideoPlayVisible(true);
  };
  //查看弹窗
  const detailModal = () => {
    return (
      <div>
        <Modal
          //getContainer={false}
          title={'课程详情'}
          width={1000}
          destroyOnClose
          visible={isDetailModalVisible}
          // confirmLoading={loading}
          // maskStyle={{ opacity: '0.1', background: '#666666' }}
          onCancel={handleDetailModalCancel}
          footer={[
            <Button
              onClick={() => {
                handleDetailModalCancel();
              }}
              key="detail"
              type="primary"
            >
              关闭
            </Button>,
          ]}
        >
          <Tabs
            defaultActiveKey="1"
            onChange={onPageChange}
            activeKey={currentPageKey}
          >
            <TabPane tab="考勤记录" key="1">
              {/* <div style={{ minHeight: 500 }}> */}
              <Title level={5}>操作</Title>
              <Space>
                {detailRecord?.status == 4 &&
                detailRecord?.trainingManner !== 2 ? (
                  <Button
                    type="primary"
                    onClick={() => forceClose(detailRecord)}
                  >
                    解散房间
                  </Button>
                ) : (
                  ''
                )}
                {detailRecord?.status == 2 ||
                (detailRecord?.status == 1 &&
                  detailRecord?.trainingManner !== 2 &&
                  isMinsIn(detailRecord?.startTimeMs, 5)) ? (
                  <Button type="primary" onClick={() => patrol(detailRecord)}>
                    巡课
                  </Button>
                ) : (
                  ''
                )}
                {detailRecord?.highlightsReady &&
                detailRecord?.highlightsBlocked &&
                detailRecord?.trainingManner !== 2 ? (
                  <Button
                    type="primary"
                    onClick={() => releasePlayback(detailRecord)}
                  >
                    释放回看
                  </Button>
                ) : (
                  ''
                )}
                {detailRecord?.highlightsReady &&
                !detailRecord?.highlightsBlocked &&
                detailRecord?.trainingManner !== 2 ? (
                  <Button
                    type="primary"
                    onClick={() => blockPlayback(detailRecord)}
                  >
                    拦截回看
                  </Button>
                ) : (
                  ''
                )}
              </Space>

              <br />
              <br />
              {classDetailDescriptions()}
              <br />
              <Title level={5}>出勤记录</Title>
              {attendTable()}
              {/* </div> */}
            </TabPane>
            <TabPane tab="上课内容" key="2">
              {classContentOP()}
            </TabPane>
            <TabPane tab="用户视频及点评" key="4">
              {/* 课堂复盘（需求 7123729254）：仅当这节课推过爆单群「线上指导课完课总结」卡片
                  （后端口径 = 线上指导课 + 有完课总结记录）才展示，与「视频信息」区块互不影响 */}
              {!!detailRecord?.hasClassReview && (
                <>
                  <Paragraph>
                    <blockquote>课堂复盘</blockquote>
                  </Paragraph>
                  <Button
                    type="primary"
                    onClick={() => {
                      const { origin } = window.location;
                      const pathname = `/litta-palmer/technical/classPlayback?roomId=${detailRecord?.roomId}`;
                      window.open(origin + pathname);
                    }}
                  >
                    查看复盘
                  </Button>
                  <br />
                </>
              )}
              <Paragraph>
                <blockquote>视频信息</blockquote>
              </Paragraph>
              {remarkDetailData?.promotionVideoModels?.length > 0 ? (
                <Space size={[16, 16]} wrap>
                  {remarkDetailData?.promotionVideoModels?.map(
                    (item, index) => {
                      return (
                        <div
                          key={index}
                          style={{
                            width: '172px',
                            height: '98px',
                            position: 'relative',
                          }}
                        >
                          <Image
                            width={'172px'}
                            height={'98px'}
                            preview={false}
                            style={{ objectFit: 'cover' }}
                            src={item?.coverUrl}
                          />
                          <PlayCircleOutlined
                            style={{
                              position: 'absolute',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%,-50%)',
                              fontSize: '30px',
                              color: '#fff',
                            }}
                            onClick={() => {
                              goPreview(item?.videoUrl);
                            }}
                          />
                        </div>
                      );
                    },
                  )}
                </Space>
              ) : !!detailRecord?.playbackUrl ? (
                <Button
                  type="primary"
                  onClick={() =>
                    playback(detailRecord?.playbackUrl, detailRecord)
                  }
                >
                  回看
                </Button>
              ) : (
                '暂无视频'
              )}
              <br />

              <Paragraph>
                <blockquote>回放总结</blockquote>
              </Paragraph>

              <div
                style={{
                  background: '#f9f9f9',
                  padding: '12px 16px',
                  borderRadius: '6px',
                  marginBottom: '16px',
                  border: '1px solid #e8e8e8',
                  lineHeight: '1.6',
                  color: '#333',
                  whiteSpace: 'pre-wrap',
                  position: 'relative',
                }}
              >
                {summaryLoading ? (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    <span
                      className="loading-spinner"
                      style={{
                        display: 'inline-block',
                        width: '16px',
                        height: '16px',
                        border: '2px solid #f3f3f3',
                        borderTop: '2px solid #1890ff',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                      }}
                    ></span>
                    等待总结结果中...
                  </div>
                ) : (
                  commentData?.playBackSummarize || '暂无回放总结内容'
                )}
              </div>

              {/* VTT文件展示 */}
              {commentData?.vttUrl && (
                <div
                  style={{
                    background: '#f0f8ff',
                    padding: '12px 16px',
                    borderRadius: '6px',
                    marginBottom: '16px',
                    border: '1px solid #d9d9d9',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                  }}
                >
                  <span
                    style={{
                      fontSize: '14px',
                      color: '#666',
                      fontWeight: '500',
                    }}
                  >
                    字幕文件：
                  </span>
                  <a
                    href={commentData.vttUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: '#1890ff',
                      textDecoration: 'none',
                      fontSize: '14px',
                    }}
                    onMouseEnter={(e) =>
                      (e.target.style.textDecoration = 'underline')
                    }
                    onMouseLeave={(e) =>
                      (e.target.style.textDecoration = 'none')
                    }
                  >
                    查看字幕文件
                  </a>
                  <Button
                    type="link"
                    size="small"
                    onClick={() => {
                      // 复制链接到剪贴板
                      navigator.clipboard
                        .writeText(commentData.vttUrl)
                        .then(() => {
                          message.success('链接已复制到剪贴板');
                        })
                        .catch(() => {
                          message.error('复制失败');
                        });
                    }}
                    style={{ padding: '0 4px', height: 'auto' }}
                  >
                    复制链接
                  </Button>
                </div>
              )}

              {/* 新增输入框和发送按钮 - 只在有回放总结时显示 */}
              {commentData?.playBackSummarize &&
                commentData.playBackSummarize !== '暂无回放总结内容' && (
                  <div style={{ marginBottom: '16px' }}>
                    <Input.Group compact>
                      <TextArea
                        style={{
                          width: 'calc(100% - 80px)',
                          resize: 'none',
                          minHeight: '32px',
                          maxHeight: '120px',
                        }}
                        placeholder="说点什么"
                        value={summaryInput}
                        onChange={(e) => setSummaryInput(e.target.value)}
                        onPressEnter={(e) => {
                          if (!e.shiftKey) {
                            e.preventDefault();
                            handleSummarySend();
                          }
                        }}
                        disabled={summaryLoading}
                        autoSize={{
                          minRows: 1,
                          maxRows: 4,
                        }}
                      />
                      <Button
                        type="primary"
                        loading={summaryLoading}
                        onClick={handleSummarySend}
                        style={{
                          width: '80px',
                          height: 'auto',
                          minHeight: '32px',
                        }}
                      >
                        发送
                      </Button>
                    </Input.Group>
                  </div>
                )}

              <Paragraph>
                <blockquote>精彩瞬间</blockquote>
              </Paragraph>

              <Space size={[16, 16]} wrap>
                {remarkDetailData?.highlightImages?.map((item, index) => {
                  return (
                    <Image
                      key={index}
                      width={'172px'}
                      height={'98px'}
                      style={{ objectFit: 'cover' }}
                      src={item}
                    />
                  );
                })}
              </Space>

              <ClassActionView
                detailRecord={classCommentRecord}
                infoList={classCommentInfoList}
              />
            </TabPane>
            <TabPane tab="教练评语" key="3">
              {classListItemView()}
            </TabPane>
            <TabPane tab="完课信息" key="5">
              <CourserInfoView
                completeClassInfo={completeClassInfo}
                completeClassCommentInfo={completeClassCommentInfo}
                isDetailModalVisible={isDetailModalVisible}
              />
            </TabPane>
            {detailRecord?.category === 2 &&
              detailRecord?.classInTrainingMethods === 1 &&
              detailRecord?.courseTrainingMethods === 1 && (
                <>
                  <TabPane tab="课程可信结果" key="6">
                    {credibilityTab()}
                  </TabPane>
                  <TabPane tab="动作评估" key="7">
                    <V3AnalysisTab
                      roomId={detailRecord?.roomId}
                      v3Data={v3Data}
                      loading={v3Loading}
                    />
                  </TabPane>
                </>
              )}
          </Tabs>
        </Modal>
      </div>
    );
  };
  //巡课弹窗
  const patrolModal = () => {
    return (
      <Modal
        //getContainer={false}
        title={'巡课'}
        width={1000}
        visible={isPatrolModalVisible}
        // maskStyle={{ opacity: '0.1', background: '#666666' }}
        onCancel={handlePatrolModalCancel}
        footer={[]}
      >
        <Row justify="center" align="middle" gutter={[16, 20]}>
          <Col hidden={!inputQRUrl} span={24} justify="center" align="middle">
            <QRCode
              // id={`id_${record.key}`}
              id={'QRC'}
              value={inputQRUrl}
              size={200}
            />
          </Col>
          <Col span={24} justify="center" align="middle">
            <a>{!inputQRUrl ? '暂无巡课二维码' : '微信扫码进行巡课'}</a>
          </Col>

          <Col span={24} justify="center" align="middle">
            <Input.Group compact>
              <Input
                style={{ width: 'calc(100% - 200px)' }}
                defaultValue={inputH5Url}
                onChange={qrCodeInputChange}
              />
              <CopyToClipboard
                text={inputH5Url}
                onCopy={() => Message.success('复制链接成功', 5)}
              >
                <Button type="primary">复制链接</Button>
              </CopyToClipboard>
            </Input.Group>
          </Col>

          {inputLiveUrl ? (
            <Col span={24} justify="center" align="middle">
              <Button
                type="primary"
                onClick={() => playLive(inputLiveUrl)}
                icon={<PlayCircleOutlined />}
                size="large"
              >
                查看直播
              </Button>
            </Col>
          ) : (
            ''
          )}
        </Row>
      </Modal>
    );
  };
  const actionFormRef = useRef();
  const actionRef = useRef();
  const detailRef = useRef();
  const autoOpenedRef = useRef(false); // 标记是否已自动打开详情

  function handleCancelModal() {
    cancelCourseForm.resetFields();
    setIsCancelModalVisible(false);
  }

  function onSubmitCancelClass() {
    cancelCourseForm.validateFields().then((values) => {
      cancelClass({
        requestData: {
          ...values,
          roomId: cancelRecord?.roomId,
          channel: 2,
        },
      }).then(({ data, code, msg }) => {
        if (code === '00000') {
          actionRef.current.reload();
          setCancelRecord(undefined);
          setIsCancelModalVisible(false);
        } else {
          message.error(msg);
        }
      });
    });
  }

  const itemLayout = {
    wrapperCol: {
      span: 8,
      offset: 8,
    },
  };
  //取消弹窗
  const cancelClassModal = () => {
    return (
      <div>
        <Modal
          title={'取消课表'}
          width={800}
          visible={isCancelModalVisible}
          onCancel={handleCancelModal}
          footer={null}
        >
          <Form
            form={cancelCourseForm}
            name="cancelCourseForm"
            onFinish={onSubmitCancelClass}
            {...cancelFormItemLayout}
          >
            <Form.Item
              name={'xxx'}
              label={'爽约说明'}
              hidden={cancelRecord?.category === 2}
            >
              <div>{cancelData?.remark}</div>
              <div>{cancelData?.startTimeWarn}</div>
              <div style={{ fontSize: 12, color: 'gray' }}>
                {cancelData?.cancelWarn}
              </div>
              {/* <div>课程已开始，2小时以内取消预约仍会扣除指导次数</div>
              <div style={{ fontSize: 12, color: 'gray' }}>
                上课前2小时以上可以无责取消上课，距离上课不足2小时取消将扣除权益，具体咨询您的专属顾问
              </div> */}
            </Form.Item>

            <Form.Item
              name={'reasonCode'}
              label={'取消原因'}
              rules={[
                {
                  required: true,
                  message: '请输入',
                },
              ]}
            >
              <Radio.Group>
                {reasonList.map((e) => {
                  return (
                    <Radio value={e.reasonCode} key={e.reasonCode}>
                      {e.reason}
                    </Radio>
                  );
                })}
              </Radio.Group>
            </Form.Item>

            <Form.Item
              name={'remark'}
              label={'备注事项'}
              rules={[
                {
                  required: false,
                  message: '请输入',
                },
              ]}
            >
              <TextArea
                allowClear
                placeholder="140个字符以内"
                autoSize={{ minRows: 3, maxRows: 6 }}
                maxLength={140}
                showCount
              ></TextArea>
            </Form.Item>
            <Form.Item {...itemLayout}>
              <div style={{ textAlign: 'center' }}>
                <Button htmlType="button" onClick={handleCancelModal}>
                  {'取消'}
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginLeft: 20 }}
                >
                  {'保存'}
                </Button>
              </div>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  };

  function viewCancelReason(record) {
    getCancelInfo({
      requestData: {
        roomId: record.roomId,
      },
    }).then(({ data, code, msg }) => {
      if (code === '00000') {
        setReasonRecord(data);
      } else {
        message.error(msg);
      }
    });
    setIsReasonModalVisible(true);
  }

  function handleReasonCancel() {
    setReasonRecord(undefined);
    setIsReasonModalVisible(false);
  }

  //取消弹窗
  const cancelReasonModal = () => {
    return (
      <div>
        <Modal
          title={'取消原因'}
          width={600}
          visible={isReasonModalVisible}
          onCancel={handleReasonCancel}
          footer={null}
        >
          <Descriptions>
            <Descriptions.Item label="操作人" span={3}>
              {reasonRecord?.optName}
            </Descriptions.Item>
            <Descriptions.Item label="操作方式" span={3}>
              {reasonRecord?.channelName}
            </Descriptions.Item>
            <Descriptions.Item label="操作时间" span={3}>
              {reasonRecord?.ctime}
            </Descriptions.Item>
            <Descriptions.Item label="取消原因" span={3}>
              {reasonRecord?.reason}
            </Descriptions.Item>
            <Descriptions.Item label="备注说明" span={3}>
              {reasonRecord?.remark}
            </Descriptions.Item>
          </Descriptions>
        </Modal>
      </div>
    );
  };

  // 处理回放总结发送
  const handleSummarySend = async () => {
    if (!summaryInput.trim()) {
      message.warning('请输入内容');
      return;
    }

    setSummaryLoading(true);

    // 在等待期间显示加载状态
    setCommentData({
      ...commentData,
      playBackSummarize: '等待总结结果中...',
    });

    try {
      const response = await summarize({
        requestData: {
          roomId: commentData?.roomId || detailRecord?.roomId, // 使用房间ID
          content: summaryInput,
          vttUrl: commentData?.vttUrl || detailRecord?.vttUrl,
        },
      });

      if (response.code === '00000') {
        // 更新回放总结内容为接口返回的文本
        setCommentData({
          ...commentData,
          playBackSummarize: response.data.summarizeText, // 使用接口返回的summarizeText字段
        });
        setSummaryInput(''); // 清空输入框
        message.success('总结生成成功');
      } else {
        // 恢复原来的内容
        setCommentData({
          ...commentData,
          playBackSummarize:
            commentData?.playBackSummarize || '暂无回放总结内容',
        });
        message.error(response.msg || '总结生成失败');
      }
    } catch (error) {
      console.error('总结生成失败:', error);
      // 恢复原来的内容
      setCommentData({
        ...commentData,
        playBackSummarize: commentData?.playBackSummarize || '暂无回放总结内容',
      });
      message.error('总结生成失败，请重试');
    } finally {
      setSummaryLoading(false);
    }
  };

  // 作业点评
  function commentClassAction(record, isPop = true) {
    remarkDetailByRoomId({
      requestData: {
        roomId: record.roomId,
      },
    }).then(({ code, msg, data }) => {
      setClassCommentVisible(isPop);
      if (code === '00000') {
        setClassCommentRecord(data.commentOrderInformation);
        setClassCommentInfoList(data.remarkDetailInformationList || []);
        setRemarkDetailData(data || {});
      } else {
        setClassCommentRecord(null);
        setClassCommentInfoList([]);
        setRemarkDetailData({});
        message.error(msg);
      }
    });
  }

  return (
    <div ref={ref}>
      <ProTable
        columns={columns}
        actionRef={actionRef}
        formRef={actionFormRef}
        request={async (params) => {
          // 自动打开场景：清除时间过滤，确保能找到目标房间
          const query = history.location.query || {};
          let requestParams = { ...params };
          if (
            query.openDetail === 'true' &&
            query.roomId &&
            !autoOpenedRef.current
          ) {
            delete requestParams.startTimeStart;
            delete requestParams.startTimeEnd;
          }
          const { data, page, code } = await queryClassList({
            requestData: {
              userPhone: userRecordInit ? userPhoneInit : '',
              userId: userIdInit,
              ...requestParams,
              sort: sort ? sort : 'asc',
            },
            page: {
              currentPage: requestParams.current,
              pageSize: requestParams.pageSize,
            },
          });
          if (code !== '00000') {
            return {
              success: false,
            };
          }
          // 自动打开详情 Modal（支持 URL 直接跳转到动作评估页）
          if (
            query.openDetail === 'true' &&
            query.roomId &&
            !autoOpenedRef.current
          ) {
            const targetRoomId = Number(query.roomId);
            const record = data?.find((item) => item.roomId === targetRoomId);
            if (record) {
              autoOpenedRef.current = true;
              // 延迟执行，确保 DOM 已渲染
              setTimeout(() => {
                detail(record);
                if (query.tab) {
                  // 使用 onPageChange 确保经过校验逻辑
                  onPageChange(query.tab);
                }
              }, 300);
            }
          }
          return {
            data: data,
            success: true,
            total: page.count,
          };
        }}
        columnsState={{
          persistenceKey: 'pro-table-singe-demos',
          persistenceType: 'localStorage',
        }}
        rowKey={(record) => record.roomId}
        search={{
          labelWidth: '100',
          defaultCollapsed: userRecordInit ? true : false,
        }}
        scroll={{ x: 'max-content' }}
        pagination={{
          defaultPageSize: 10,
        }}
        dateFormatter="string"
        toolBarRender={
          userRecordInit
            ? false
            : () => [
                <Button
                  key="orderButton"
                  onClick={() => {
                    order();
                  }}
                  type="primary"
                >
                  预约上课
                </Button>,
              ]
        }
      />

      {orderModal()}
      {renderVideoModal()}
      {detailModal()}
      {modifyModal()}
      {patrolModal()}
      {cancelClassModal()}
      {cancelReasonModal()}
      <ClassCommentView
        visible={classCommentVisible}
        setVisible={setClassCommentVisible}
        detailRecord={classCommentRecord}
        infoList={classCommentInfoList}
      />
      <ModalVideo
        visible={liveVideoPlayVisible}
        src={liveVideoPlaySrc}
        onCancel={() => {
          setLiveVideoPlayVisible(false);
        }}
      />
    </div>
  );
};

export default forwardRef(ClassList);
